var items = {
  "block.minecraft.acacia_button": "Хуайс модон товч",
  "block.minecraft.acacia_door": "Хуайс модон хаалга",
  "block.minecraft.acacia_fence": "Хуайс модон хашаа",
  "block.minecraft.acacia_fence_gate": "Хуайс модон хашааны хаалга",
  "block.minecraft.acacia_hanging_sign": "Хуайс модон дүүжилдэг самбар",
  "block.minecraft.acacia_leaves": "Хуайс модны навч",
  "block.minecraft.acacia_log": "Хуайс модон дүнз",
  "block.minecraft.acacia_planks": "Хуайс модон банз",
  "block.minecraft.acacia_pressure_plate": "Хуайс модон даралтын хавтан",
  "block.minecraft.acacia_sapling": "Зулзаган хуайс мод",
  "block.minecraft.acacia_shelf": "Хуайс модон тавиур",
  "block.minecraft.acacia_sign": "Хуайс модон самбар",
  "block.minecraft.acacia_slab": "Хуайс модон хавтан",
  "block.minecraft.acacia_stairs": "Хуайс модон шат",
  "block.minecraft.acacia_trapdoor": "Хуайс модон сөхдөг хаалга",
  "block.minecraft.acacia_wall_hanging_sign": "Хуайс модон хананаас дүүжилдэг самбар",
  "block.minecraft.acacia_wall_sign": "Хуайс модон ханын самбар",
  "block.minecraft.acacia_wood": "Хуайс мод",
  "block.minecraft.activator_rail": "Идэвхжүүлэгч төмөр зам",
  "block.minecraft.air": "Агаар",
  "block.minecraft.allium": "Халиар",
  "block.minecraft.amethyst_block": "Ягаан болор блок",
  "block.minecraft.amethyst_cluster": "Ягаан болрын хонгорцог",
  "block.minecraft.ancient_debris": "Эртний металл",
  "block.minecraft.andesite": "Андезит",
  "block.minecraft.andesite_slab": "Андезит хавтан",
  "block.minecraft.andesite_stairs": "Андезит шат",
  "block.minecraft.andesite_wall": "Андезит хана",
  "block.minecraft.anvil": "Дөш",
  "block.minecraft.attached_melon_stem": "Тарвастай иш",
  "block.minecraft.attached_pumpkin_stem": "Хулуутай иш",
  "block.minecraft.azalea": "Азалиа",
  "block.minecraft.azalea_leaves": "Aзалиан навч",
  "block.minecraft.azure_bluet": "Хонгорзул",
  "block.minecraft.bamboo": "Хулс",
  "block.minecraft.bamboo_block": "Хулсан блок",
  "block.minecraft.bamboo_button": "Хулсан товч",
  "block.minecraft.bamboo_door": "Хулсан хаалга",
  "block.minecraft.bamboo_fence": "Хулсан хашаа",
  "block.minecraft.bamboo_fence_gate": "Хулсан хашааны хаалга",
  "block.minecraft.bamboo_hanging_sign": "Хулсан дүүжилдэг самбар",
  "block.minecraft.bamboo_mosaic": "Хулсан мозайк",
  "block.minecraft.bamboo_mosaic_slab": "Хулсан мозайк хавтан",
  "block.minecraft.bamboo_mosaic_stairs": "Хулсан мозайк шат",
  "block.minecraft.bamboo_planks": "Хулсан банз",
  "block.minecraft.bamboo_pressure_plate": "Хулсан даралтын хавтан",
  "block.minecraft.bamboo_sapling": "Хулсны нахиа",
  "block.minecraft.bamboo_shelf": "Хулс модон тавиур",
  "block.minecraft.bamboo_sign": "Хулсан самбар",
  "block.minecraft.bamboo_slab": "Хулсан хавтан",
  "block.minecraft.bamboo_stairs": "Хулсан шат",
  "block.minecraft.bamboo_trapdoor": "Хулсан сөхдөг хаалга",
  "block.minecraft.bamboo_wall_hanging_sign": "Хулсан хананаас дүүжилдэг самбар",
  "block.minecraft.bamboo_wall_sign": "Хулсан хананы самбар",
  "block.minecraft.banner.base.black": "Хар дэвсгэр",
  "block.minecraft.banner.base.blue": "Хөх дэвсгэр",
  "block.minecraft.banner.base.brown": "Бор дэвсгэр",
  "block.minecraft.banner.base.cyan": "Номин цэнхэр дэвсгэр",
  "block.minecraft.banner.base.gray": "Саарал дэвсгэр",
  "block.minecraft.banner.base.green": "Ногоон дэвсгэр",
  "block.minecraft.banner.base.light_blue": "Цэнхэр дэвсгэр",
  "block.minecraft.banner.base.light_gray": "Цайвар саарал дэвсгэр",
  "block.minecraft.banner.base.lime": "Цайвар ногоон дэвсгэр",
  "block.minecraft.banner.base.magenta": "Ягаан дэвсгэр",
  "block.minecraft.banner.base.orange": "Улбар шар дэвсгэр",
  "block.minecraft.banner.base.pink": "Цайвар ягаан дэвсгэр",
  "block.minecraft.banner.base.purple": "Нил ягаан дэвсгэр",
  "block.minecraft.banner.base.red": "Улаан дэвсгэр",
  "block.minecraft.banner.base.white": "Цагаан дэвсгэр",
  "block.minecraft.banner.base.yellow": "Шар дэвсгэр",
  "block.minecraft.banner.border.black": "Хар хүрээ",
  "block.minecraft.banner.border.blue": "Хөх хүрээ",
  "block.minecraft.banner.border.brown": "Бор хүрээ",
  "block.minecraft.banner.border.cyan": "Номин цэнхэр хүрээ",
  "block.minecraft.banner.border.gray": "Саарал хүрээ",
  "block.minecraft.banner.border.green": "Ногоон хүрээ",
  "block.minecraft.banner.border.light_blue": "Цэнхэр хүрээ",
  "block.minecraft.banner.border.light_gray": "Цайвар саарал хүрээ",
  "block.minecraft.banner.border.lime": "Цайвар ногоон хүрээ",
  "block.minecraft.banner.border.magenta": "Ягаан хүрээ",
  "block.minecraft.banner.border.orange": "Улбар шар хүрээ",
  "block.minecraft.banner.border.pink": "Цайвар ягаан хүрээ",
  "block.minecraft.banner.border.purple": "Нил ягаан хүрээ",
  "block.minecraft.banner.border.red": "Улаан хүрээ",
  "block.minecraft.banner.border.white": "Цагаан хүрээ",
  "block.minecraft.banner.border.yellow": "Шар хүрээ",
  "block.minecraft.banner.bricks.black": "Хар тоосгон хээ",
  "block.minecraft.banner.bricks.blue": "Хөх тоосгон хээ",
  "block.minecraft.banner.bricks.brown": "Бор тоосгон хээ",
  "block.minecraft.banner.bricks.cyan": "Номин цэнхэр тоосгон хээ",
  "block.minecraft.banner.bricks.gray": "Саарал тоосгон хээ",
  "block.minecraft.banner.bricks.green": "Ногоон тоосгон хээ",
  "block.minecraft.banner.bricks.light_blue": "Цэнхэр тоосгон хээ",
  "block.minecraft.banner.bricks.light_gray": "Цайвар саарал тоосгон хээ",
  "block.minecraft.banner.bricks.lime": "Цайвар ногоон тоосгон хээ",
  "block.minecraft.banner.bricks.magenta": "Ягаан тоосгон хээ",
  "block.minecraft.banner.bricks.orange": "Улбар шар тоосгон хээ",
  "block.minecraft.banner.bricks.pink": "Цайвар ягаан тоосгон хээ",
  "block.minecraft.banner.bricks.purple": "Нил ягаан тоосгон хээ",
  "block.minecraft.banner.bricks.red": "Улаан тоосгон хээ",
  "block.minecraft.banner.bricks.white": "Цагаан тоосгон хээ",
  "block.minecraft.banner.bricks.yellow": "Шар тоосгон хээ",
  "block.minecraft.banner.circle.black": "Хар дугуй",
  "block.minecraft.banner.circle.blue": "Хөх дугуй",
  "block.minecraft.banner.circle.brown": "Бор дугуй",
  "block.minecraft.banner.circle.cyan": "Номин цэнхэр дугуй",
  "block.minecraft.banner.circle.gray": "Саарал дугуй",
  "block.minecraft.banner.circle.green": "Ногоон дугуй",
  "block.minecraft.banner.circle.light_blue": "Цэнхэр дугуй",
  "block.minecraft.banner.circle.light_gray": "Цайвар саарал дугуй",
  "block.minecraft.banner.circle.lime": "Цайвар ногоон дугуй",
  "block.minecraft.banner.circle.magenta": "Ягаан дугуй",
  "block.minecraft.banner.circle.orange": "Улбар шар дугуй",
  "block.minecraft.banner.circle.pink": "Цайвар ягаан дугуй",
  "block.minecraft.banner.circle.purple": "Нил ягаан дугуй",
  "block.minecraft.banner.circle.red": "Улаан дугуй",
  "block.minecraft.banner.circle.white": "Цагаан дугуй",
  "block.minecraft.banner.circle.yellow": "Шар дугуй",
  "block.minecraft.banner.creeper.black": "Хар криперийн нүүр",
  "block.minecraft.banner.creeper.blue": "Хөх криперийн нүүр",
  "block.minecraft.banner.creeper.brown": "Бор криперийн нүүр",
  "block.minecraft.banner.creeper.cyan": "Номин цэнхэр криперийн нүүр",
  "block.minecraft.banner.creeper.gray": "Саарал криперийн нүүр",
  "block.minecraft.banner.creeper.green": "Ногоон криперийн нүүр",
  "block.minecraft.banner.creeper.light_blue": "Цэнхэр криперийн нүүр",
  "block.minecraft.banner.creeper.light_gray": "Цайвар саарал криперийн нүүр",
  "block.minecraft.banner.creeper.lime": "Цайвар ногоон криперийн нүүр",
  "block.minecraft.banner.creeper.magenta": "Ягаан криперийн нүүр",
  "block.minecraft.banner.creeper.orange": "Улбар шар криперийн нүүр",
  "block.minecraft.banner.creeper.pink": "Цайвар ягаан криперийн нүүр",
  "block.minecraft.banner.creeper.purple": "Нил ягаан криперийн нүүр",
  "block.minecraft.banner.creeper.red": "Улаан криперийн нүүр",
  "block.minecraft.banner.creeper.white": "Цагаан криперийн нүүр",
  "block.minecraft.banner.creeper.yellow": "Шар криперийн нүүр",
  "block.minecraft.banner.cross.black": "Хар солбисон шугам",
  "block.minecraft.banner.cross.blue": "Хөх солбисон шугам",
  "block.minecraft.banner.cross.brown": "Бор солбисон шугам",
  "block.minecraft.banner.cross.cyan": "Номин цэнхэр солбисон шугам",
  "block.minecraft.banner.cross.gray": "Саарал солбисон шугам",
  "block.minecraft.banner.cross.green": "Ногоон солбисон шугам",
  "block.minecraft.banner.cross.light_blue": "Цэнхэр солбисон шугам",
  "block.minecraft.banner.cross.light_gray": "Цайвар саарал солбисон шугам",
  "block.minecraft.banner.cross.lime": "Цайвар ногоон солбисон шугам",
  "block.minecraft.banner.cross.magenta": "Ягаан солбисон шугам",
  "block.minecraft.banner.cross.orange": "Улбар шар солбисон шугам",
  "block.minecraft.banner.cross.pink": "Цайвар ягаан солбисон шугам",
  "block.minecraft.banner.cross.purple": "Нил ягаан солбисон шугам",
  "block.minecraft.banner.cross.red": "Улаан солбисон шугам",
  "block.minecraft.banner.cross.white": "Цагаан солбисон шугам",
  "block.minecraft.banner.cross.yellow": "Шар солбисон шугам",
  "block.minecraft.banner.curly_border.black": "Хар арзгар хүрээ",
  "block.minecraft.banner.curly_border.blue": "Хөх арзгар хүрээ",
  "block.minecraft.banner.curly_border.brown": "Бор арзгар хүрээ",
  "block.minecraft.banner.curly_border.cyan": "Номин цэнхэр арзгар хүрээ",
  "block.minecraft.banner.curly_border.gray": "Саарал арзгар хүрээ",
  "block.minecraft.banner.curly_border.green": "Ногоон арзгар хүрээ",
  "block.minecraft.banner.curly_border.light_blue": "Цэнхэр арзгар хүрээ",
  "block.minecraft.banner.curly_border.light_gray": "Цайвар саарал арзгар хүрээ",
  "block.minecraft.banner.curly_border.lime": "Цайвар ногоон арзгар хүрээ",
  "block.minecraft.banner.curly_border.magenta": "Ягаан арзгар хүрээ",
  "block.minecraft.banner.curly_border.orange": "Улбар шар арзгар хүрээ",
  "block.minecraft.banner.curly_border.pink": "Цайвар ягаан арзгар хүрээ",
  "block.minecraft.banner.curly_border.purple": "Нил ягаан арзгар хүрээ",
  "block.minecraft.banner.curly_border.red": "Улаан арзгар хүрээ",
  "block.minecraft.banner.curly_border.white": "Цагаан арзгар хүрээ",
  "block.minecraft.banner.curly_border.yellow": "Шар арзгар хүрээ",
  "block.minecraft.banner.diagonal_left.black": "Хар зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.blue": "Хөх зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.brown": "Бор зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.cyan": "Номин цэнхэр зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.gray": "Саарал зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.green": "Ногоон зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.light_blue": "Цэнхэр зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.light_gray": "Цайвар саарал зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.lime": "Цайвар ногоон зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.magenta": "Ягаан зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.orange": "Улбар шар зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.pink": "Цайвар ягаан зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.purple": "Нил ягаан зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.red": "Улаан зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.white": "Цагаан зүүн дээд хагас",
  "block.minecraft.banner.diagonal_left.yellow": "Шар зүүн дээд хагас",
  "block.minecraft.banner.diagonal_right.black": "Хар баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.blue": "Хөх баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.brown": "Бор баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.cyan": "Номин цэнхэр баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.gray": "Саарал баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.green": "Ногоон баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.light_blue": "Цэнхэр баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.light_gray": "Цайвар саарал баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.lime": "Цайвар ногоон баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.magenta": "Ягаан баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.orange": "Улбар шар баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.pink": "Цайвар ягаан баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.purple": "Нил ягаан баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.red": "Улаан баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.white": "Цагаан баруун дээд хагас",
  "block.minecraft.banner.diagonal_right.yellow": "Шар баруун дээд хагас",
  "block.minecraft.banner.diagonal_up_left.black": "Хар зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.blue": "Хөх зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.brown": "Бор зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.cyan": "Номин цэнхэр зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.gray": "Саарал зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.green": "Ногоон зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Цэнхэр зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Цайвар саарал зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.lime": "Цайвар ногоон зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.magenta": "Ягаан зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.orange": "Улбар шар зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.pink": "Цайвар ягаан зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.purple": "Нил ягаан зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.red": "Улаан зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.white": "Цагаан зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_left.yellow": "Шар зүүн доод хагас",
  "block.minecraft.banner.diagonal_up_right.black": "Хар баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.blue": "Хөх баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.brown": "Бор баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.cyan": "Номин цэнхэр баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.gray": "Саарал баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.green": "Ногоон баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Цэнхэр баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Цайвар саарал баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.lime": "Цайвар ногоон баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.magenta": "Ягаан баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.orange": "Улбар шар баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.pink": "Цайвар ягаан баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.purple": "Нил ягаан баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.red": "Улаан баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.white": "Цагаан баруун доод хагас",
  "block.minecraft.banner.diagonal_up_right.yellow": "Шар баруун доод хагас",
  "block.minecraft.banner.flow.black": "Хар урсгал",
  "block.minecraft.banner.flow.blue": "Хөх урсгал",
  "block.minecraft.banner.flow.brown": "Бор урсгал",
  "block.minecraft.banner.flow.cyan": "Номин цэнхэр урсгал",
  "block.minecraft.banner.flow.gray": "Саарал урсгал",
  "block.minecraft.banner.flow.green": "Ногоон урсгал",
  "block.minecraft.banner.flow.light_blue": "Цэнхэр урсгал",
  "block.minecraft.banner.flow.light_gray": "Цайвар саарал урсгал",
  "block.minecraft.banner.flow.lime": "Цайвар ногоон урсгал",
  "block.minecraft.banner.flow.magenta": "Ягаан урсгал",
  "block.minecraft.banner.flow.orange": "Улбар шар урсгал",
  "block.minecraft.banner.flow.pink": "Цайвар ягаан урсгал",
  "block.minecraft.banner.flow.purple": "Нил ягаан урсгал",
  "block.minecraft.banner.flow.red": "Улаан урсгал",
  "block.minecraft.banner.flow.white": "Цагаан урсгал",
  "block.minecraft.banner.flow.yellow": "Шар урсгал",
  "block.minecraft.banner.flower.black": "Хар цэцэг",
  "block.minecraft.banner.flower.blue": "Хөх цэцэг",
  "block.minecraft.banner.flower.brown": "Бор цэцэг",
  "block.minecraft.banner.flower.cyan": "Номин цэнхэр цэцэг",
  "block.minecraft.banner.flower.gray": "Саарал цэцэг",
  "block.minecraft.banner.flower.green": "Ногоон цэцэг",
  "block.minecraft.banner.flower.light_blue": "Цэнхэр цэцэг",
  "block.minecraft.banner.flower.light_gray": "Цайвар саарал цэцэг",
  "block.minecraft.banner.flower.lime": "Цайвар ногоон цэцэг",
  "block.minecraft.banner.flower.magenta": "Ягаан цэцэг",
  "block.minecraft.banner.flower.orange": "Улбар шар цэцэг",
  "block.minecraft.banner.flower.pink": "Цайвар ягаан цэцэг",
  "block.minecraft.banner.flower.purple": "Нил ягаан цэцэг",
  "block.minecraft.banner.flower.red": "Улаан цэцэг",
  "block.minecraft.banner.flower.white": "Цагаан цэцэг",
  "block.minecraft.banner.flower.yellow": "Шар цэцэг",
  "block.minecraft.banner.globe.black": "Хар бөмбөрцөг",
  "block.minecraft.banner.globe.blue": "Хөх бөмбөрцөг",
  "block.minecraft.banner.globe.brown": "Бор бөмбөрцөг",
  "block.minecraft.banner.globe.cyan": "Номин цэнхэр бөмбөрцөг",
  "block.minecraft.banner.globe.gray": "Саарал бөмбөрцөг",
  "block.minecraft.banner.globe.green": "Ногоон бөмбөрцөг",
  "block.minecraft.banner.globe.light_blue": "Цэнхэр бөмбөрцөг",
  "block.minecraft.banner.globe.light_gray": "Цайвар саарал бөмбөрцөг",
  "block.minecraft.banner.globe.lime": "Цайвар ногоон бөмбөрцөг",
  "block.minecraft.banner.globe.magenta": "Ягаан бөмбөрцөг",
  "block.minecraft.banner.globe.orange": "Улбар шар бөмбөрцөг",
  "block.minecraft.banner.globe.pink": "Цайвар ягаан бөмбөрцөг",
  "block.minecraft.banner.globe.purple": "Нил ягаан бөмбөрцөг",
  "block.minecraft.banner.globe.red": "Улаан бөмбөрцөг",
  "block.minecraft.banner.globe.white": "Цагаан бөмбөрцөг",
  "block.minecraft.banner.globe.yellow": "Шар бөмбөрцөг",
  "block.minecraft.banner.gradient.black": "Хар дээрээс доош уусалт",
  "block.minecraft.banner.gradient.blue": "Хөх дээрээс доош уусалт",
  "block.minecraft.banner.gradient.brown": "Бор дээрээс доош уусалт",
  "block.minecraft.banner.gradient.cyan": "Номин цэнхэр дээрээс доош уусалт",
  "block.minecraft.banner.gradient.gray": "Саарал дээрээс доош уусалт",
  "block.minecraft.banner.gradient.green": "Ногоон дээрээс доош уусалт",
  "block.minecraft.banner.gradient.light_blue": "Цэнхэр дээрээс доош уусалт",
  "block.minecraft.banner.gradient.light_gray": "Цайвар саарал дээрээс доош уусалт",
  "block.minecraft.banner.gradient.lime": "Цайвар ногоон дээрээс доош уусалт",
  "block.minecraft.banner.gradient.magenta": "Ягаан дээрээс доош уусалт",
  "block.minecraft.banner.gradient.orange": "Улбар шар дээрээс доош уусалт",
  "block.minecraft.banner.gradient.pink": "Цайвар ягаан дээрээс доош уусалт",
  "block.minecraft.banner.gradient.purple": "Нил ягаан дээрээс доош уусалт",
  "block.minecraft.banner.gradient.red": "Улаан дээрээс доош уусалт",
  "block.minecraft.banner.gradient.white": "Цагаан дээрээс доош уусалт",
  "block.minecraft.banner.gradient.yellow": "Шар дээрээс доош уусалт",
  "block.minecraft.banner.gradient_up.black": "Хар доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.blue": "Хөх доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.brown": "Бор доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.cyan": "Номин цэнхэр доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.gray": "Саарал доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.green": "Ногоон доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.light_blue": "Цэнхэр доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.light_gray": "Цайвар саарал доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.lime": "Цайвар ногоон доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.magenta": "Ягаан доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.orange": "Улбар шар доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.pink": "Цайвар ягаан доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.purple": "Нил ягаан доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.red": "Улаан доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.white": "Цагаан доороос дээш уусалт",
  "block.minecraft.banner.gradient_up.yellow": "Шар доороос дээш уусалт",
  "block.minecraft.banner.guster.black": "Хар шуурга",
  "block.minecraft.banner.guster.blue": "Хөх шуурга",
  "block.minecraft.banner.guster.brown": "Бор шуурга",
  "block.minecraft.banner.guster.cyan": "Номин цэнхэр шуурга",
  "block.minecraft.banner.guster.gray": "Саарал шуурга",
  "block.minecraft.banner.guster.green": "Ногоон шуурга",
  "block.minecraft.banner.guster.light_blue": "Цайвар цэнхэр шуурга",
  "block.minecraft.banner.guster.light_gray": "Цайвар саарал шуурга",
  "block.minecraft.banner.guster.lime": "Цайвар ногоон шуурга",
  "block.minecraft.banner.guster.magenta": "Ягаан шуурга",
  "block.minecraft.banner.guster.orange": "Улбар шар шуурга",
  "block.minecraft.banner.guster.pink": "Цайвар ягаан шуурга",
  "block.minecraft.banner.guster.purple": "Нил ягаан шуурга",
  "block.minecraft.banner.guster.red": "Улаан шуурга",
  "block.minecraft.banner.guster.white": "Цагаан шуурга",
  "block.minecraft.banner.guster.yellow": "Шар шуурга",
  "block.minecraft.banner.half_horizontal.black": "Хар дээд хагас",
  "block.minecraft.banner.half_horizontal.blue": "Хөх дээд хагас",
  "block.minecraft.banner.half_horizontal.brown": "Бор дээд хагас",
  "block.minecraft.banner.half_horizontal.cyan": "Номин цэнхэр дээд хагас",
  "block.minecraft.banner.half_horizontal.gray": "Саарал дээд хагас",
  "block.minecraft.banner.half_horizontal.green": "Ногоон дээд хагас",
  "block.minecraft.banner.half_horizontal.light_blue": "Цэнхэр дээд хагас",
  "block.minecraft.banner.half_horizontal.light_gray": "Цайвар саарал дээд хагас",
  "block.minecraft.banner.half_horizontal.lime": "Цайвар ногоон дээд хагас",
  "block.minecraft.banner.half_horizontal.magenta": "Ягаан дээд хагас",
  "block.minecraft.banner.half_horizontal.orange": "Улбар шар дээд хагас",
  "block.minecraft.banner.half_horizontal.pink": "Цайвар ягаан дээд хагас",
  "block.minecraft.banner.half_horizontal.purple": "Нил ягаан дээд хагас",
  "block.minecraft.banner.half_horizontal.red": "Улаан дээд хагас",
  "block.minecraft.banner.half_horizontal.white": "Цагаан дээд хагас",
  "block.minecraft.banner.half_horizontal.yellow": "Шар дээд хагас",
  "block.minecraft.banner.half_horizontal_bottom.black": "Хар доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Хөх доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Бор доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Номин цэнхэр доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Саарал доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.green": "Ногоон доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Цэнхэр доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Цайвар саарал доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Цайвар ногоон доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Ягаан доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Улбар шар доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Цайвар ягаан доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Нил ягаан доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.red": "Улаан доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.white": "Цагаан доод хагас",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Шар доод хагас",
  "block.minecraft.banner.half_vertical.black": "Хар зүүн хагас",
  "block.minecraft.banner.half_vertical.blue": "Хөх зүүн хагас",
  "block.minecraft.banner.half_vertical.brown": "Бор зүүн хагас",
  "block.minecraft.banner.half_vertical.cyan": "Номин цэнхэр зүүн хагас",
  "block.minecraft.banner.half_vertical.gray": "Саарал зүүн хагас",
  "block.minecraft.banner.half_vertical.green": "Ногоон зүүн хагас",
  "block.minecraft.banner.half_vertical.light_blue": "Цэнхэр зүүн хагас",
  "block.minecraft.banner.half_vertical.light_gray": "Цайвар саарал зүүн хагас",
  "block.minecraft.banner.half_vertical.lime": "Цайвар ногоон зүүн хагас",
  "block.minecraft.banner.half_vertical.magenta": "Ягаан зүүн хагас",
  "block.minecraft.banner.half_vertical.orange": "Улбар шар зүүн хагас",
  "block.minecraft.banner.half_vertical.pink": "Цайвар ягаан зүүн хагас",
  "block.minecraft.banner.half_vertical.purple": "Нил ягаан зүүн хагас",
  "block.minecraft.banner.half_vertical.red": "Улаан зүүн хагас",
  "block.minecraft.banner.half_vertical.white": "Цагаан зүүн хагас",
  "block.minecraft.banner.half_vertical.yellow": "Шар зүүн хагас",
  "block.minecraft.banner.half_vertical_right.black": "Хар баруун хагас",
  "block.minecraft.banner.half_vertical_right.blue": "Хөх баруун хагас",
  "block.minecraft.banner.half_vertical_right.brown": "Бор баруун хагас",
  "block.minecraft.banner.half_vertical_right.cyan": "Номин цэнхэр баруун хагас",
  "block.minecraft.banner.half_vertical_right.gray": "Саарал баруун хагас",
  "block.minecraft.banner.half_vertical_right.green": "Ногоон баруун хагас",
  "block.minecraft.banner.half_vertical_right.light_blue": "Цэнхэр баруун хагас",
  "block.minecraft.banner.half_vertical_right.light_gray": "Цайвар саарал баруун хагас",
  "block.minecraft.banner.half_vertical_right.lime": "Цайвар ногоон баруун хагас",
  "block.minecraft.banner.half_vertical_right.magenta": "Ягаан баруун хагас",
  "block.minecraft.banner.half_vertical_right.orange": "Улбар шар баруун хагас",
  "block.minecraft.banner.half_vertical_right.pink": "Цайвар ягаан баруун хагас",
  "block.minecraft.banner.half_vertical_right.purple": "Нил ягаан баруун хагас",
  "block.minecraft.banner.half_vertical_right.red": "Улаан баруун хагас",
  "block.minecraft.banner.half_vertical_right.white": "Цагаан баруун хагас",
  "block.minecraft.banner.half_vertical_right.yellow": "Шар баруун хагас",
  "block.minecraft.banner.mojang.black": "Хар зүйл",
  "block.minecraft.banner.mojang.blue": "Хөх зүйл",
  "block.minecraft.banner.mojang.brown": "Бор зүйл",
  "block.minecraft.banner.mojang.cyan": "Номин цэнхэр зүйл",
  "block.minecraft.banner.mojang.gray": "Саарал зүйл",
  "block.minecraft.banner.mojang.green": "Ногоон зүйл",
  "block.minecraft.banner.mojang.light_blue": "Цэнхэр зүйл",
  "block.minecraft.banner.mojang.light_gray": "Цайвар зүйл",
  "block.minecraft.banner.mojang.lime": "Цайвар ногоон зүйл",
  "block.minecraft.banner.mojang.magenta": "Ягаан зүйл",
  "block.minecraft.banner.mojang.orange": "Улбар шар зүйл",
  "block.minecraft.banner.mojang.pink": "Цайвар ягаан зүйл",
  "block.minecraft.banner.mojang.purple": "Нил ягаан зүйл",
  "block.minecraft.banner.mojang.red": "Улаан зүйл",
  "block.minecraft.banner.mojang.white": "Цагаан зүйл",
  "block.minecraft.banner.mojang.yellow": "Шар зүйл",
  "block.minecraft.banner.piglin.black": "Хар хоншоор",
  "block.minecraft.banner.piglin.blue": "Хөх хоншоор",
  "block.minecraft.banner.piglin.brown": "Бор хоншоор",
  "block.minecraft.banner.piglin.cyan": "Номин цэнхэр хоншоор",
  "block.minecraft.banner.piglin.gray": "Саарал хоншоор",
  "block.minecraft.banner.piglin.green": "Ногоон хоншоор",
  "block.minecraft.banner.piglin.light_blue": "Цэнхэр хоншоор",
  "block.minecraft.banner.piglin.light_gray": "Цайвар саарал хоншоор",
  "block.minecraft.banner.piglin.lime": "Цайвар ногоон хоншоор",
  "block.minecraft.banner.piglin.magenta": "Ягаан хоншоор",
  "block.minecraft.banner.piglin.orange": "Улбар шар хоншоор",
  "block.minecraft.banner.piglin.pink": "Цайвар ягаан хоншоор",
  "block.minecraft.banner.piglin.purple": "Нил ягаан хоншоор",
  "block.minecraft.banner.piglin.red": "Улаан хоншоор",
  "block.minecraft.banner.piglin.white": "Цагаан хоншоор",
  "block.minecraft.banner.piglin.yellow": "Шар хоншоор",
  "block.minecraft.banner.rhombus.black": "Хар ромбо",
  "block.minecraft.banner.rhombus.blue": "Хөх ромбо",
  "block.minecraft.banner.rhombus.brown": "Бор ромбо",
  "block.minecraft.banner.rhombus.cyan": "Номин цэнхэр ромбо",
  "block.minecraft.banner.rhombus.gray": "Саарал ромбо",
  "block.minecraft.banner.rhombus.green": "Ногоон ромбо",
  "block.minecraft.banner.rhombus.light_blue": "Цэнхэр ромбо",
  "block.minecraft.banner.rhombus.light_gray": "Цайвар саарал ромбо",
  "block.minecraft.banner.rhombus.lime": "Цайвар ногоон ромбо",
  "block.minecraft.banner.rhombus.magenta": "Ягаан ромбо",
  "block.minecraft.banner.rhombus.orange": "Улбар шар ромбо",
  "block.minecraft.banner.rhombus.pink": "Цайвар ягаан ромбо",
  "block.minecraft.banner.rhombus.purple": "Нил ягаан ромбо",
  "block.minecraft.banner.rhombus.red": "Улаан ромбо",
  "block.minecraft.banner.rhombus.white": "Цагаан ромбо",
  "block.minecraft.banner.rhombus.yellow": "Шар ромбо",
  "block.minecraft.banner.skull.black": "Хар гавлын яс",
  "block.minecraft.banner.skull.blue": "Хөх гавлын яс",
  "block.minecraft.banner.skull.brown": "Бор гавлын яс",
  "block.minecraft.banner.skull.cyan": "Номин цэнхэр гавлын яс",
  "block.minecraft.banner.skull.gray": "Саарал гавлын яс",
  "block.minecraft.banner.skull.green": "Ногоон гавлын яс",
  "block.minecraft.banner.skull.light_blue": "Цэнхэр гавлын яс",
  "block.minecraft.banner.skull.light_gray": "Цайвар саарал гавлын яс",
  "block.minecraft.banner.skull.lime": "Цайвар ногоон гавлын яс",
  "block.minecraft.banner.skull.magenta": "Ягаан гавлын яс",
  "block.minecraft.banner.skull.orange": "Улбар шар гавлын яс",
  "block.minecraft.banner.skull.pink": "Цайвар ягаан гавлын яс",
  "block.minecraft.banner.skull.purple": "Нил ягаан гавлын яс",
  "block.minecraft.banner.skull.red": "Улаан гавлын яс",
  "block.minecraft.banner.skull.white": "Цагаан гавлын яс",
  "block.minecraft.banner.skull.yellow": "Шар гавлын яс",
  "block.minecraft.banner.small_stripes.black": "Хар босоо судал",
  "block.minecraft.banner.small_stripes.blue": "Хөх босоо судал",
  "block.minecraft.banner.small_stripes.brown": "Бор босоо судал",
  "block.minecraft.banner.small_stripes.cyan": "Номин цэнхэр босоо судал",
  "block.minecraft.banner.small_stripes.gray": "Саарал босоо судал",
  "block.minecraft.banner.small_stripes.green": "Ногоон босоо судал",
  "block.minecraft.banner.small_stripes.light_blue": "Цэнхэр босоо судал",
  "block.minecraft.banner.small_stripes.light_gray": "Цайвар саарал босоо судал",
  "block.minecraft.banner.small_stripes.lime": "Цайвар ногоон босоо судал",
  "block.minecraft.banner.small_stripes.magenta": "Ягаан босоо судал",
  "block.minecraft.banner.small_stripes.orange": "Улбар шар босоо судал",
  "block.minecraft.banner.small_stripes.pink": "Цайвар ягаан босоо судал",
  "block.minecraft.banner.small_stripes.purple": "Нил ягаан босоо судал",
  "block.minecraft.banner.small_stripes.red": "Улаан босоо судал",
  "block.minecraft.banner.small_stripes.white": "Цагаан босоо судал",
  "block.minecraft.banner.small_stripes.yellow": "Шар босоо судал",
  "block.minecraft.banner.square_bottom_left.black": "Хар зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.blue": "Хөх зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.brown": "Бор зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.cyan": "Номин цэнхэр зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.gray": "Саарал зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.green": "Ногоон зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.light_blue": "Цэнхэр зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.light_gray": "Цайвар саарал зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.lime": "Цайвар ногоон зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.magenta": "Ягаан зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.orange": "Улбар шар зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.pink": "Цайвар ягаан зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.purple": "Нил ягаан зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.red": "Улаан зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.white": "Цагаан зүүн доод булан",
  "block.minecraft.banner.square_bottom_left.yellow": "Шар зүүн доод булан",
  "block.minecraft.banner.square_bottom_right.black": "Хар баруун доод булан",
  "block.minecraft.banner.square_bottom_right.blue": "Хөх баруун доод булан",
  "block.minecraft.banner.square_bottom_right.brown": "Бор баруун доод булан",
  "block.minecraft.banner.square_bottom_right.cyan": "Номин цэнхэр баруун доод булан",
  "block.minecraft.banner.square_bottom_right.gray": "Саарал баруун доод булан",
  "block.minecraft.banner.square_bottom_right.green": "Ногоон баруун доод булан",
  "block.minecraft.banner.square_bottom_right.light_blue": "Цэнхэр баруун доод булан",
  "block.minecraft.banner.square_bottom_right.light_gray": "Цайвар саарал баруун доод булан",
  "block.minecraft.banner.square_bottom_right.lime": "Цайвар ногоон баруун доод булан",
  "block.minecraft.banner.square_bottom_right.magenta": "Ягаан баруун доод булан",
  "block.minecraft.banner.square_bottom_right.orange": "Улбар шар баруун доод булан",
  "block.minecraft.banner.square_bottom_right.pink": "Цайвар ягаан баруун доод булан",
  "block.minecraft.banner.square_bottom_right.purple": "Нил ягаан баруун доод булан",
  "block.minecraft.banner.square_bottom_right.red": "Улаан баруун доод булан",
  "block.minecraft.banner.square_bottom_right.white": "Цагаан баруун доод булан",
  "block.minecraft.banner.square_bottom_right.yellow": "Шар баруун доод булан",
  "block.minecraft.banner.square_top_left.black": "Хар зүүн дээд булан",
  "block.minecraft.banner.square_top_left.blue": "Хөх зүүн дээд булан",
  "block.minecraft.banner.square_top_left.brown": "Бор зүүн дээд булан",
  "block.minecraft.banner.square_top_left.cyan": "Номин цэнхэр зүүн дээд булан",
  "block.minecraft.banner.square_top_left.gray": "Саарал зүүн дээд булан",
  "block.minecraft.banner.square_top_left.green": "Ногоон зүүн дээд булан",
  "block.minecraft.banner.square_top_left.light_blue": "Цэнхэр зүүн дээд булан",
  "block.minecraft.banner.square_top_left.light_gray": "Цайвар саарал зүүн дээд булан",
  "block.minecraft.banner.square_top_left.lime": "Цайвар ногоон зүүн дээд булан",
  "block.minecraft.banner.square_top_left.magenta": "Ягаан зүүн дээд булан",
  "block.minecraft.banner.square_top_left.orange": "Улбар шар зүүн дээд булан",
  "block.minecraft.banner.square_top_left.pink": "Цайвар ягаан зүүн дээд булан",
  "block.minecraft.banner.square_top_left.purple": "Нил ягаан зүүн дээд булан",
  "block.minecraft.banner.square_top_left.red": "Улаан зүүн дээд булан",
  "block.minecraft.banner.square_top_left.white": "Цагаан зүүн дээд булан",
  "block.minecraft.banner.square_top_left.yellow": "Шар зүүн дээд булан",
  "block.minecraft.banner.square_top_right.black": "Хар баруун дээд булан",
  "block.minecraft.banner.square_top_right.blue": "Хөх баруун дээд булан",
  "block.minecraft.banner.square_top_right.brown": "Бор баруун дээд булан",
  "block.minecraft.banner.square_top_right.cyan": "Номин цэнхэр баруун дээд булан",
  "block.minecraft.banner.square_top_right.gray": "Саарал баруун дээд булан",
  "block.minecraft.banner.square_top_right.green": "Ногоон баруун дээд булан",
  "block.minecraft.banner.square_top_right.light_blue": "Цэнхэр баруун дээд булан",
  "block.minecraft.banner.square_top_right.light_gray": "Цайвар саарал баруун дээд булан",
  "block.minecraft.banner.square_top_right.lime": "Цайвар ногоон баруун дээд булан",
  "block.minecraft.banner.square_top_right.magenta": "Ягаан баруун дээд булан",
  "block.minecraft.banner.square_top_right.orange": "Улбар шар баруун дээд булан",
  "block.minecraft.banner.square_top_right.pink": "Цайвар ягаан баруун дээд булан",
  "block.minecraft.banner.square_top_right.purple": "Нил ягаан баруун дээд булан",
  "block.minecraft.banner.square_top_right.red": "Улаан баруун дээд булан",
  "block.minecraft.banner.square_top_right.white": "Цагаан баруун дээд булан",
  "block.minecraft.banner.square_top_right.yellow": "Шар баруун дээд булан",
  "block.minecraft.banner.straight_cross.black": "Хар загалмай",
  "block.minecraft.banner.straight_cross.blue": "Хөх загалмай",
  "block.minecraft.banner.straight_cross.brown": "Бор загалмай",
  "block.minecraft.banner.straight_cross.cyan": "Номин цэнхэр загалмай",
  "block.minecraft.banner.straight_cross.gray": "Саарал загалмай",
  "block.minecraft.banner.straight_cross.green": "Ногоон загалмай",
  "block.minecraft.banner.straight_cross.light_blue": "Цэнхэр загалмай",
  "block.minecraft.banner.straight_cross.light_gray": "Цайвар саарал загалмай",
  "block.minecraft.banner.straight_cross.lime": "Цайвар ногоон загалмай",
  "block.minecraft.banner.straight_cross.magenta": "Ягаан загалмай",
  "block.minecraft.banner.straight_cross.orange": "Улбар шар загалмай",
  "block.minecraft.banner.straight_cross.pink": "Цайвар ягаан загалмай",
  "block.minecraft.banner.straight_cross.purple": "Нил ягаан загалмай",
  "block.minecraft.banner.straight_cross.red": "Улаан загалмай",
  "block.minecraft.banner.straight_cross.white": "Цагаан загалмай",
  "block.minecraft.banner.straight_cross.yellow": "Шар загалмай",
  "block.minecraft.banner.stripe_bottom.black": "Хар доод хэсэг",
  "block.minecraft.banner.stripe_bottom.blue": "Хөх доод хэсэг",
  "block.minecraft.banner.stripe_bottom.brown": "Бор доод хэсэг",
  "block.minecraft.banner.stripe_bottom.cyan": "Номин цэнхэр доод хэсэг",
  "block.minecraft.banner.stripe_bottom.gray": "Саарал доод хэсэг",
  "block.minecraft.banner.stripe_bottom.green": "Ногоон доод хэсэг",
  "block.minecraft.banner.stripe_bottom.light_blue": "Цэнхэр доод хэсэг",
  "block.minecraft.banner.stripe_bottom.light_gray": "Цайвар саарал доод хэсэг",
  "block.minecraft.banner.stripe_bottom.lime": "Цайвар ногоон доод хэсэг",
  "block.minecraft.banner.stripe_bottom.magenta": "Ягаан доод хэсэг",
  "block.minecraft.banner.stripe_bottom.orange": "Улбар шар доод хэсэг",
  "block.minecraft.banner.stripe_bottom.pink": "Цайвар ягаан доод хэсэг",
  "block.minecraft.banner.stripe_bottom.purple": "Нил ягаан доод хэсэг",
  "block.minecraft.banner.stripe_bottom.red": "Улаан доод хэсэг",
  "block.minecraft.banner.stripe_bottom.white": "Цагаан доод хэсэг",
  "block.minecraft.banner.stripe_bottom.yellow": "Шар доод хэсэг",
  "block.minecraft.banner.stripe_center.black": "Хар босоо зураас",
  "block.minecraft.banner.stripe_center.blue": "Хөх босоо зураас",
  "block.minecraft.banner.stripe_center.brown": "Бор босоо зураас",
  "block.minecraft.banner.stripe_center.cyan": "Номин цэнхэр босоо зураас",
  "block.minecraft.banner.stripe_center.gray": "Саарал босоо зураас",
  "block.minecraft.banner.stripe_center.green": "Ногоон босоо зураас",
  "block.minecraft.banner.stripe_center.light_blue": "Цэнхэр босоо зураас",
  "block.minecraft.banner.stripe_center.light_gray": "Цайвар саарал босоо зураас",
  "block.minecraft.banner.stripe_center.lime": "Цайвар ногоон босоо зураас",
  "block.minecraft.banner.stripe_center.magenta": "Ягаан босоо зураас",
  "block.minecraft.banner.stripe_center.orange": "Улбар шар босоо зураас",
  "block.minecraft.banner.stripe_center.pink": "Цайвар ягаан босоо зураас",
  "block.minecraft.banner.stripe_center.purple": "Нил ягаан босоо зураас",
  "block.minecraft.banner.stripe_center.red": "Улаан босоо зураас",
  "block.minecraft.banner.stripe_center.white": "Цагаан босоо зураас",
  "block.minecraft.banner.stripe_center.yellow": "Шар босоо зураас",
  "block.minecraft.banner.stripe_downleft.black": "Хар эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.blue": "Хөх эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.brown": "Бор эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.cyan": "Номин цэнхэр эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.gray": "Саарал эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.green": "Ногоон эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.light_blue": "Цэнхэр эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.light_gray": "Цайвар саарал эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.lime": "Цайвар ногоон эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.magenta": "Ягаан эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.orange": "Улбар шар эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.pink": "Цайвар ягаан эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.purple": "Нил ягаан эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.red": "Улаан эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.white": "Цагаан эсрэг диагональ",
  "block.minecraft.banner.stripe_downleft.yellow": "Шар эсрэг диагональ",
  "block.minecraft.banner.stripe_downright.black": "Хар диагональ",
  "block.minecraft.banner.stripe_downright.blue": "Хөх диагональ",
  "block.minecraft.banner.stripe_downright.brown": "Бор диагональ",
  "block.minecraft.banner.stripe_downright.cyan": "Номин цэнхэр диагональ",
  "block.minecraft.banner.stripe_downright.gray": "Саарал диагональ",
  "block.minecraft.banner.stripe_downright.green": "Ногоон диагональ",
  "block.minecraft.banner.stripe_downright.light_blue": "Цэнхэр диагональ",
  "block.minecraft.banner.stripe_downright.light_gray": "Цайвар саарал диагональ",
  "block.minecraft.banner.stripe_downright.lime": "Цайвар ногоон диагональ",
  "block.minecraft.banner.stripe_downright.magenta": "Ягаан ташуу зураас",
  "block.minecraft.banner.stripe_downright.orange": "Улбар шар ташуу зураас",
  "block.minecraft.banner.stripe_downright.pink": "Цайвар ягаан диагональ",
  "block.minecraft.banner.stripe_downright.purple": "Нил ягаан диагональ",
  "block.minecraft.banner.stripe_downright.red": "Улаан диагональ",
  "block.minecraft.banner.stripe_downright.white": "Цагаан ташуу зураас",
  "block.minecraft.banner.stripe_downright.yellow": "Шар диагональ",
  "block.minecraft.banner.stripe_left.black": "Хар зүүн хэсэг",
  "block.minecraft.banner.stripe_left.blue": "Хөх зүүн хэсэг",
  "block.minecraft.banner.stripe_left.brown": "Бор зүүн хэсэг",
  "block.minecraft.banner.stripe_left.cyan": "Номин цэнхэр зүүн хэсэг",
  "block.minecraft.banner.stripe_left.gray": "Саарал зүүн хэсэг",
  "block.minecraft.banner.stripe_left.green": "Ногоон зүүн хэсэг",
  "block.minecraft.banner.stripe_left.light_blue": "Цэнхэр зүүн хэсэг",
  "block.minecraft.banner.stripe_left.light_gray": "Цайвар саарал зүүн хэсэг",
  "block.minecraft.banner.stripe_left.lime": "Цайвар ногоон зүүн хэсэг",
  "block.minecraft.banner.stripe_left.magenta": "Ягаан зүүн хэсэг",
  "block.minecraft.banner.stripe_left.orange": "Улбар шар зүүн хэсэг",
  "block.minecraft.banner.stripe_left.pink": "Цайвар ягаан зүүн хэсэг",
  "block.minecraft.banner.stripe_left.purple": "Нил ягаан зүүн хэсэг",
  "block.minecraft.banner.stripe_left.red": "Улаан зүүн хэсэг",
  "block.minecraft.banner.stripe_left.white": "Цагаан зүүн хэсэг",
  "block.minecraft.banner.stripe_left.yellow": "Шар зүүн хэсэг",
  "block.minecraft.banner.stripe_middle.black": "Хар хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.blue": "Хөх хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.brown": "Бор хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.cyan": "Номин цэнхэр хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.gray": "Саарал хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.green": "Ногоон хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.light_blue": "Цэнхэр хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.light_gray": "Цайвар саарал хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.lime": "Цайвар ногоон хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.magenta": "Ягаан хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.orange": "Улбар шар хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.pink": "Цайвар ягаан хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.purple": "Нил ягаан хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.red": "Улаан хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.white": "Цагаан хөндлөн шугам",
  "block.minecraft.banner.stripe_middle.yellow": "Шар хөндлөн шугам",
  "block.minecraft.banner.stripe_right.black": "Хар баруун хэсэг",
  "block.minecraft.banner.stripe_right.blue": "Хөх баруун хэсэг",
  "block.minecraft.banner.stripe_right.brown": "Бор баруун хэсэг",
  "block.minecraft.banner.stripe_right.cyan": "Номин цэнхэр баруун хэсэг",
  "block.minecraft.banner.stripe_right.gray": "Саарал баруун хэсэг",
  "block.minecraft.banner.stripe_right.green": "Ногоон баруун хэсэг",
  "block.minecraft.banner.stripe_right.light_blue": "Цэнхэр баруун хэсэг",
  "block.minecraft.banner.stripe_right.light_gray": "Цайвар саарал баруун хэсэг",
  "block.minecraft.banner.stripe_right.lime": "Цайвар ногоон баруун хэсэг",
  "block.minecraft.banner.stripe_right.magenta": "Ягаан баруун хэсэг",
  "block.minecraft.banner.stripe_right.orange": "Улбар шар баруун хэсэг",
  "block.minecraft.banner.stripe_right.pink": "Цайвар ягаан баруун хэсэг",
  "block.minecraft.banner.stripe_right.purple": "Нил ягаан баруун хэсэг",
  "block.minecraft.banner.stripe_right.red": "Улаан баруун хэсэг",
  "block.minecraft.banner.stripe_right.white": "Цагаан баруун хэсэг",
  "block.minecraft.banner.stripe_right.yellow": "Шар баруун хэсэг",
  "block.minecraft.banner.stripe_top.black": "Хар дээд хэсэг",
  "block.minecraft.banner.stripe_top.blue": "Хөх дээд хэсэг",
  "block.minecraft.banner.stripe_top.brown": "Бор дээд хэсэг",
  "block.minecraft.banner.stripe_top.cyan": "Номин цэнхэр дээд хэсэг",
  "block.minecraft.banner.stripe_top.gray": "Саарал дээд хэсэг",
  "block.minecraft.banner.stripe_top.green": "Ногоон дээд хэсэг",
  "block.minecraft.banner.stripe_top.light_blue": "Цэнхэр дээд хэсэг",
  "block.minecraft.banner.stripe_top.light_gray": "Цайвар саарал дээд хэсэг",
  "block.minecraft.banner.stripe_top.lime": "Цайвар ногоон дээд хэсэг",
  "block.minecraft.banner.stripe_top.magenta": "Ягаан дээд хэсэг",
  "block.minecraft.banner.stripe_top.orange": "Улбар шар дээд хэсэг",
  "block.minecraft.banner.stripe_top.pink": "Цайвар ягаан дээд хэсэг",
  "block.minecraft.banner.stripe_top.purple": "Нил ягаан дээд хэсэг",
  "block.minecraft.banner.stripe_top.red": "Улаан дээд хэсэг",
  "block.minecraft.banner.stripe_top.white": "Цагаан дээд хэсэг",
  "block.minecraft.banner.stripe_top.yellow": "Шар дээд хэсэг",
  "block.minecraft.banner.triangle_bottom.black": "Хар дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.blue": "Хөх дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.brown": "Бор дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.cyan": "Номин цэнхэр дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.gray": "Саарал дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.green": "Ногоон дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.light_blue": "Цэнхэр дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.light_gray": "Цайвар саарал дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.lime": "Цайвар ногоон дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.magenta": "Ягаан дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.orange": "Улбар шар дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.pink": "Цайвар ягаан дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.purple": "Нил ягаан дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.red": "Улаан дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.white": "Цагаан дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_bottom.yellow": "Шар дээшээ харсан гурвалжин",
  "block.minecraft.banner.triangle_top.black": "Хар доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.blue": "Хөх доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.brown": "Бор доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.cyan": "Номин цэнхэр доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.gray": "Саарал доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.green": "Ногоон доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.light_blue": "Цэнхэр доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.light_gray": "Цайвар саарал доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.lime": "Цайвар ногоон доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.magenta": "Ягаан доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.orange": "Улбар шар доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.pink": "Цайвар ягаан доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.purple": "Нил ягаан доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.red": "Улаан доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.white": "Цагаан доошоо харсан гурвалжин",
  "block.minecraft.banner.triangle_top.yellow": "Шар доошоо харсан гурвалжин",
  "block.minecraft.banner.triangles_bottom.black": "Хар дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.blue": "Хөх дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.brown": "Бор дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.cyan": "Номин цэнхэр дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.gray": "Саарал дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.green": "Ногоон дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.light_blue": "Цэнхэр дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.light_gray": "Цайвар саарал дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.lime": "Цайвар ногоон дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.magenta": "Ягаан дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.orange": "Улбар шар дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.pink": "Цайвар ягаан дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.purple": "Нил ягаан дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.red": "Улаан дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.white": "Цагаан дээшээ харсан долгион",
  "block.minecraft.banner.triangles_bottom.yellow": "Шар дээшээ харсан долгион",
  "block.minecraft.banner.triangles_top.black": "Хар доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.blue": "Хөх доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.brown": "Бор доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.cyan": "Номин цэнхэр доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.gray": "Саарал доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.green": "Ногоон доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.light_blue": "Цэнхэр доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.light_gray": "Цайвар саарал доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.lime": "Цайвар ногоон доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.magenta": "Ягаан доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.orange": "Улбар шар доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.pink": "Цайвар ягаан доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.purple": "Нил ягаан доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.red": "Улаан доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.white": "Цагаан доошоо харсан долгион",
  "block.minecraft.banner.triangles_top.yellow": "Шар доошоо харсан долгион",
  "block.minecraft.barrel": "Торх",
  "block.minecraft.barrier": "Хаалт",
  "block.minecraft.basalt": "Базальт",
  "block.minecraft.beacon": "Гэрэл цацруулагч",
  "block.minecraft.beacon.primary": "Үндсэн хүч",
  "block.minecraft.beacon.secondary": "Хоёрдогч хүч",
  "block.minecraft.bed.no_sleep": "Шөнө эсвэл аянга цахилгаантай үед л унтаж болно",
  "block.minecraft.bed.not_safe": "Эргэн тойрон мангасууд байгаа учраас одоо амарч чадахгүй",
  "block.minecraft.bed.obstructed": "Энэ ор саадтай",
  "block.minecraft.bed.occupied": "Энэ ор хүнтэй",
  "block.minecraft.bed.too_far_away": "Таны ор хол байгаа учраас одоо амарч чадахгүй",
  "block.minecraft.bedrock": "Үндсэн чулуулаг",
  "block.minecraft.bee_nest": "Зөгийн үүр",
  "block.minecraft.beehive": "Зөгийн үүр",
  "block.minecraft.beetroots": "Улаан манжин",
  "block.minecraft.bell": "Хонх",
  "block.minecraft.big_dripleaf": "Том гоожингор навч",
  "block.minecraft.big_dripleaf_stem": "Том гоожингор навчны иш",
  "block.minecraft.birch_button": "Хус модон товч",
  "block.minecraft.birch_door": "Хус модон хаалга",
  "block.minecraft.birch_fence": "Хус модон хашаа",
  "block.minecraft.birch_fence_gate": "Хус модон хашааны хаалга",
  "block.minecraft.birch_hanging_sign": "Хус модон дүүжилдэг самбар",
  "block.minecraft.birch_leaves": "Хус модны навч",
  "block.minecraft.birch_log": "Хус модон дүнз",
  "block.minecraft.birch_planks": "Хус модон банз",
  "block.minecraft.birch_pressure_plate": "Хус модон даралтын хавтан",
  "block.minecraft.birch_sapling": "Зулзаган хус мод",
  "block.minecraft.birch_shelf": "Хус модон тавиур",
  "block.minecraft.birch_sign": "Хус модон самбар",
  "block.minecraft.birch_slab": "Хус модон хавтан",
  "block.minecraft.birch_stairs": "Хус модон шат",
  "block.minecraft.birch_trapdoor": "Хус модон сөхдөг хаалга",
  "block.minecraft.birch_wall_hanging_sign": "Хус модон хананаас дүүжилдэг самбар",
  "block.minecraft.birch_wall_sign": "Хус модон ханын самбар",
  "block.minecraft.birch_wood": "Хус мод",
  "block.minecraft.black_banner": "Хар туг",
  "block.minecraft.black_bed": "Хар ор",
  "block.minecraft.black_candle": "Хар лаа",
  "block.minecraft.black_candle_cake": "Хар лаатай бялуу",
  "block.minecraft.black_carpet": "Хар хивс",
  "block.minecraft.black_concrete": "Хар бетон",
  "block.minecraft.black_concrete_powder": "Хар нунтаг бетон",
  "block.minecraft.black_glazed_terracotta": "Хар хээтэй шавар",
  "block.minecraft.black_shulker_box": "Хар шалкер хайрцаг",
  "block.minecraft.black_stained_glass": "Хар будагтай шил",
  "block.minecraft.black_stained_glass_pane": "Хар будагтай шилэн хавтан",
  "block.minecraft.black_terracotta": "Хар хатуу шавар",
  "block.minecraft.black_wool": "Хар ноос",
  "block.minecraft.blackstone": "Хар чулуу",
  "block.minecraft.blackstone_slab": "Хар чулуун хавтан",
  "block.minecraft.blackstone_stairs": "Хар чулуун шат",
  "block.minecraft.blackstone_wall": "Хар чулуун хана",
  "block.minecraft.blast_furnace": "Хайлуулах зуух",
  "block.minecraft.blue_banner": "Хөх туг",
  "block.minecraft.blue_bed": "Хөх ор",
  "block.minecraft.blue_candle": "Хөх лаа",
  "block.minecraft.blue_candle_cake": "Хөх лаатай бялуу",
  "block.minecraft.blue_carpet": "Хөх хивс",
  "block.minecraft.blue_concrete": "Хөх бетон",
  "block.minecraft.blue_concrete_powder": "Хөх нунтаг бетон",
  "block.minecraft.blue_glazed_terracotta": "Хөх хээтэй шавар",
  "block.minecraft.blue_ice": "Хөх мөс",
  "block.minecraft.blue_orchid": "Хөх цахирмаа",
  "block.minecraft.blue_shulker_box": "Хөх шалкер хайрцаг",
  "block.minecraft.blue_stained_glass": "Хөх будагтай шил",
  "block.minecraft.blue_stained_glass_pane": "Хөх будагтай шилэн хавтан",
  "block.minecraft.blue_terracotta": "Хөх хатуу шавар",
  "block.minecraft.blue_wool": "Хөх ноос",
  "block.minecraft.bone_block": "Ясан блок",
  "block.minecraft.bookshelf": "Номын тавиур",
  "block.minecraft.brain_coral": "Угалзарсан шүр",
  "block.minecraft.brain_coral_block": "Угалзарсан шүрэн блок",
  "block.minecraft.brain_coral_fan": "Угалзарсан шүрэн дэвүүр",
  "block.minecraft.brain_coral_wall_fan": "Угалзарсан шүрэн дэвүүр хананд",
  "block.minecraft.brewing_stand": "Ханд нэрэгч",
  "block.minecraft.brick_slab": "Тоосгон хавтан",
  "block.minecraft.brick_stairs": "Тоосгон шат",
  "block.minecraft.brick_wall": "Тоосгон хана",
  "block.minecraft.bricks": "Тоосгон блок",
  "block.minecraft.brown_banner": "Бор туг",
  "block.minecraft.brown_bed": "Бор ор",
  "block.minecraft.brown_candle": "Бор лаа",
  "block.minecraft.brown_candle_cake": "Бор лаатай бялуу",
  "block.minecraft.brown_carpet": "Бор хивс",
  "block.minecraft.brown_concrete": "Бор бетон",
  "block.minecraft.brown_concrete_powder": "Бор нунтаг бетон",
  "block.minecraft.brown_glazed_terracotta": "Бор хээтэй шавар",
  "block.minecraft.brown_mushroom": "Бор мөөг",
  "block.minecraft.brown_mushroom_block": "Бор мөөгөн блок",
  "block.minecraft.brown_shulker_box": "Бор шалкер хайрцаг",
  "block.minecraft.brown_stained_glass": "Бор будагтай шил",
  "block.minecraft.brown_stained_glass_pane": "Бор будагтай шилэн хавтан",
  "block.minecraft.brown_terracotta": "Бор хатуу шавар",
  "block.minecraft.brown_wool": "Бор ноос",
  "block.minecraft.bubble_column": "Хөөсөн багана",
  "block.minecraft.bubble_coral": "Бөмбөлөг шүр",
  "block.minecraft.bubble_coral_block": "Бөмбөлөг шүрэн блок",
  "block.minecraft.bubble_coral_fan": "Бөмбөлөг шүрэн дэвүүр",
  "block.minecraft.bubble_coral_wall_fan": "Бөмбөлөг шүрэн дэвүүр хананд",
  "block.minecraft.budding_amethyst": "Нахиалагч ягаан болор",
  "block.minecraft.bush": "Бут",
  "block.minecraft.cactus": "Кактус",
  "block.minecraft.cactus_flower": "Кактусын цэцэг",
  "block.minecraft.cake": "Бялуу",
  "block.minecraft.calcite": "Кальцит",
  "block.minecraft.calibrated_sculk_sensor": "Тохируулсан мэдрэгч скалк",
  "block.minecraft.campfire": "Түүдэг гал",
  "block.minecraft.candle": "Лаа",
  "block.minecraft.candle_cake": "Лаатай бялуу",
  "block.minecraft.carrots": "Лууван",
  "block.minecraft.cartography_table": "Зураг зүйн ширээ",
  "block.minecraft.carved_pumpkin": "Сийлсэн хулуу",
  "block.minecraft.cauldron": "Тогоо",
  "block.minecraft.cave_air": "Агуйн агаар",
  "block.minecraft.cave_vines": "Агуйн ороонго",
  "block.minecraft.cave_vines_plant": "Агуйн ороонгон ургамал",
  "block.minecraft.chain": "Гинж",
  "block.minecraft.chain_command_block": "Гинжин тушаалын блок",
  "block.minecraft.cherry_button": "Интоорын модон товч",
  "block.minecraft.cherry_door": "Интоорын модон хаалга",
  "block.minecraft.cherry_fence": "Интоорын модон хашаа",
  "block.minecraft.cherry_fence_gate": "Интоорын модон хашааны хаалга",
  "block.minecraft.cherry_hanging_sign": "Интоорын модон дүүжилдэг самбар",
  "block.minecraft.cherry_leaves": "Интоорын модны навч",
  "block.minecraft.cherry_log": "Интоорын модон дүнз",
  "block.minecraft.cherry_planks": "Интоорын модон банз",
  "block.minecraft.cherry_pressure_plate": "Интоорын модон даралтын хавтан",
  "block.minecraft.cherry_sapling": "Зулзаган интоорын мод",
  "block.minecraft.cherry_shelf": "Интоорын модон тавиур",
  "block.minecraft.cherry_sign": "Интоорын модон самбар",
  "block.minecraft.cherry_slab": "Интоорын модон хавтан",
  "block.minecraft.cherry_stairs": "Интоорын модон шат",
  "block.minecraft.cherry_trapdoor": "Интоорын модон сөхдөг хаалга",
  "block.minecraft.cherry_wall_hanging_sign": "Интоорын модон хананаас дүүжилдэг самбар",
  "block.minecraft.cherry_wall_sign": "Интоорын модон ханын самбар",
  "block.minecraft.cherry_wood": "Интоорын мод",
  "block.minecraft.chest": "Авдар",
  "block.minecraft.chipped_anvil": "Эмтэрсэн дөш",
  "block.minecraft.chiseled_bookshelf": "Сийлбэртэй номын тавиур",
  "block.minecraft.chiseled_copper": "Сийлсэн зэс",
  "block.minecraft.chiseled_deepslate": "Сийлсэн гүний занар",
  "block.minecraft.chiseled_nether_bricks": "Сийлбэртэй тамын тоосго",
  "block.minecraft.chiseled_polished_blackstone": "Сийлбэртэй өнгөлсөн хар чулуу",
  "block.minecraft.chiseled_quartz_block": "Сийлсэн кварц блок",
  "block.minecraft.chiseled_red_sandstone": "Сийлсэн улаан элсэн чулуу",
  "block.minecraft.chiseled_resin_bricks": "Сийлбэртэй давирхайн тоосго",
  "block.minecraft.chiseled_sandstone": "Сийлсэн элсэн чулуу",
  "block.minecraft.chiseled_stone_bricks": "Сийлсэн чулуун тоосго",
  "block.minecraft.chiseled_tuff": "Сийлсэн туф",
  "block.minecraft.chiseled_tuff_bricks": "Сийлсэн туф тоосго",
  "block.minecraft.chorus_flower": "Дахилтат цэцэг",
  "block.minecraft.chorus_plant": "Дахилтат ургамал",
  "block.minecraft.clay": "Шавар",
  "block.minecraft.closed_eyeblossom": "Хумисан гэрэлт нүдэн",
  "block.minecraft.coal_block": "Нүүрсэн блок",
  "block.minecraft.coal_ore": "Нүүрсны хүдэр",
  "block.minecraft.coarse_dirt": "Чулуутай шороо",
  "block.minecraft.cobbled_deepslate": "Хагархай гүний занар",
  "block.minecraft.cobbled_deepslate_slab": "Хагархай гүний занар хавтан",
  "block.minecraft.cobbled_deepslate_stairs": "Хагархай гүний занар шат",
  "block.minecraft.cobbled_deepslate_wall": "Хагархай гүний занар хана",
  "block.minecraft.cobblestone": "Хагархай чулуу",
  "block.minecraft.cobblestone_slab": "Хагархай чулуун хавтан",
  "block.minecraft.cobblestone_stairs": "Хагархай чулуун шат",
  "block.minecraft.cobblestone_wall": "Хагархай чулуун хана",
  "block.minecraft.cobweb": "Аалзны тор",
  "block.minecraft.cocoa": "Какао",
  "block.minecraft.command_block": "Тушаалын блок",
  "block.minecraft.comparator": "Редстоун харьцуулагч",
  "block.minecraft.composter": "Бордооны торх",
  "block.minecraft.conduit": "Далайн хүчний ундарга",
  "block.minecraft.copper_bars": "Зэс тор",
  "block.minecraft.copper_block": "Зэс блок",
  "block.minecraft.copper_bulb": "Зэс гэрэл",
  "block.minecraft.copper_chain": "Зэс гинж",
  "block.minecraft.copper_chest": "Зэс авдар",
  "block.minecraft.copper_door": "Зэс хаалга",
  "block.minecraft.copper_golem_statue": "Зэс големын хөшөө",
  "block.minecraft.copper_grate": "Зэс сараалж",
  "block.minecraft.copper_lantern": "Зэс дэнлүү",
  "block.minecraft.copper_ore": "Зэсийн хүдэр",
  "block.minecraft.copper_torch": "Зэс бамбар",
  "block.minecraft.copper_trapdoor": "Зэс сөхдөг хаалга",
  "block.minecraft.copper_wall_torch": "Зэс хананы бамбар",
  "block.minecraft.cornflower": "Хөх хонгорзул",
  "block.minecraft.cracked_deepslate_bricks": "Хагархай гүний занар тоосго",
  "block.minecraft.cracked_deepslate_tiles": "Дөрвөлжин хээтэй хагархай гүний занар",
  "block.minecraft.cracked_nether_bricks": "Хагархай тамын тоосго",
  "block.minecraft.cracked_polished_blackstone_bricks": "Хагархай өнгөлсөн хар чулуун тоосго",
  "block.minecraft.cracked_stone_bricks": "Хагарсан чулуун тоосго",
  "block.minecraft.crafter": "Урлагч",
  "block.minecraft.crafting_table": "Урлах ширээ",
  "block.minecraft.creaking_heart": "Хяхнах зүрх",
  "block.minecraft.creeper_head": "Криперийн толгой",
  "block.minecraft.creeper_wall_head": "Криперийн толгой хананд",
  "block.minecraft.crimson_button": "Нөжит модон товч",
  "block.minecraft.crimson_door": "Нөжит модон хаалга",
  "block.minecraft.crimson_fence": "Нөжит модон хашаа",
  "block.minecraft.crimson_fence_gate": "Нөжит модон хашааны хаалга",
  "block.minecraft.crimson_fungus": "Нөжит мөөг",
  "block.minecraft.crimson_hanging_sign": "Нөжит модон дүүжилдэг самбар",
  "block.minecraft.crimson_hyphae": "Нөжит мод",
  "block.minecraft.crimson_nylium": "Нөжит хөрс",
  "block.minecraft.crimson_planks": "Нөжит модон банз",
  "block.minecraft.crimson_pressure_plate": "Нөжит модон даралтын хавтан",
  "block.minecraft.crimson_roots": "Нөжит ургамал",
  "block.minecraft.crimson_shelf": "Нөжит модон тавиур",
  "block.minecraft.crimson_sign": "Нөжит модон самбар",
  "block.minecraft.crimson_slab": "Нөжит модон хавтан",
  "block.minecraft.crimson_stairs": "Нөжит модон шат",
  "block.minecraft.crimson_stem": "Нөжит дүнз",
  "block.minecraft.crimson_trapdoor": "Нөжит модон сөхдөг хаалга",
  "block.minecraft.crimson_wall_hanging_sign": "Нөжит модон хананаас дүүжилдэг самбар",
  "block.minecraft.crimson_wall_sign": "Нөжит модон хананы самбар",
  "block.minecraft.crying_obsidian": "Уйлж буй хар шил",
  "block.minecraft.cut_copper": "Зүсмэл зэс",
  "block.minecraft.cut_copper_slab": "Зүсмэл зэс хавтан",
  "block.minecraft.cut_copper_stairs": "Зүсмэл зэс шат",
  "block.minecraft.cut_red_sandstone": "Өөлсөн улаан элсэн чулуу",
  "block.minecraft.cut_red_sandstone_slab": "Өөлсөн улаан элсэн чулуун хавтан",
  "block.minecraft.cut_sandstone": "Өөлсөн элсэн чулуу",
  "block.minecraft.cut_sandstone_slab": "Өөлсөн элсэн чулуун хавтан",
  "block.minecraft.cyan_banner": "Номин цэнхэр туг",
  "block.minecraft.cyan_bed": "Номин цэнхэр ор",
  "block.minecraft.cyan_candle": "Номин цэнхэр лаа",
  "block.minecraft.cyan_candle_cake": "Номин цэнхэр лаатай бялуу",
  "block.minecraft.cyan_carpet": "Номин цэнхэр хивс",
  "block.minecraft.cyan_concrete": "Номин цэнхэр бетон",
  "block.minecraft.cyan_concrete_powder": "Номин цэнхэр нунтаг бетон",
  "block.minecraft.cyan_glazed_terracotta": "Номин цэнхэр хээтэй шавар",
  "block.minecraft.cyan_shulker_box": "Номин цэнхэр шалкер хайрцаг",
  "block.minecraft.cyan_stained_glass": "Номин цэнхэр будагтай шил",
  "block.minecraft.cyan_stained_glass_pane": "Номин цэнхэр будагтай шилэн хавтан",
  "block.minecraft.cyan_terracotta": "Номин цэнхэр хатуу шавар",
  "block.minecraft.cyan_wool": "Номин цэнхэр ноос",
  "block.minecraft.damaged_anvil": "Эвдэрсэн дөш",
  "block.minecraft.dandelion": "Багваахай",
  "block.minecraft.dark_oak_button": "Хар царс модон товч",
  "block.minecraft.dark_oak_door": "Хар царс модон хаалга",
  "block.minecraft.dark_oak_fence": "Хар царс модон хашаа",
  "block.minecraft.dark_oak_fence_gate": "Хар царс модон хашааны хаалга",
  "block.minecraft.dark_oak_hanging_sign": "Хар царс модон дүүжилдэг самбар",
  "block.minecraft.dark_oak_leaves": "Хар царс модны навч",
  "block.minecraft.dark_oak_log": "Хар царс модон дүнз",
  "block.minecraft.dark_oak_planks": "Хар царс модон банз",
  "block.minecraft.dark_oak_pressure_plate": "Хар царс модон даралтын хавтан",
  "block.minecraft.dark_oak_sapling": "Зулзаган хар царс мод",
  "block.minecraft.dark_oak_shelf": "Хар царс модон тавиур",
  "block.minecraft.dark_oak_sign": "Хар царс модон самбар",
  "block.minecraft.dark_oak_slab": "Хар царс модон хавтан",
  "block.minecraft.dark_oak_stairs": "Хар царс модон шат",
  "block.minecraft.dark_oak_trapdoor": "Хар царс модон сөхдөг хаалга",
  "block.minecraft.dark_oak_wall_hanging_sign": "Хар царс модон хананаас дүүжилдэг самбар",
  "block.minecraft.dark_oak_wall_sign": "Хар царс модон ханын самбар",
  "block.minecraft.dark_oak_wood": "Хар царс мод",
  "block.minecraft.dark_prismarine": "Хар присмарин",
  "block.minecraft.dark_prismarine_slab": "Хар присмарин хавтан",
  "block.minecraft.dark_prismarine_stairs": "Хар присмарин шат",
  "block.minecraft.daylight_detector": "Нарны гэрэл мэдрэгч",
  "block.minecraft.dead_brain_coral": "Үхсэн угалзарсан шүр",
  "block.minecraft.dead_brain_coral_block": "Үхсэн угалзарсан шүрэн блок",
  "block.minecraft.dead_brain_coral_fan": "Үхсэн угалзарсан шүрэн дэвүүр",
  "block.minecraft.dead_brain_coral_wall_fan": "Үхсэн угалзарсан шүрэн дэвүүр хананд",
  "block.minecraft.dead_bubble_coral": "Үхсэн бөмбөлөг шүр",
  "block.minecraft.dead_bubble_coral_block": "Үхсэн бөмбөлөг шүрэн блок",
  "block.minecraft.dead_bubble_coral_fan": "Үхсэн бөмбөлөг шүрэн дэвүүр",
  "block.minecraft.dead_bubble_coral_wall_fan": "Үхсэн бөмбөлөг шүрэн дэвүүр хананд",
  "block.minecraft.dead_bush": "Үхсэн бут",
  "block.minecraft.dead_fire_coral": "Үхсэн гал шүр",
  "block.minecraft.dead_fire_coral_block": "Үхсэн гал шүрэн блок",
  "block.minecraft.dead_fire_coral_fan": "Үхсэн гал шүрэн дэвүүр",
  "block.minecraft.dead_fire_coral_wall_fan": "Үхсэн гал шүрэн дэвүүр хананд",
  "block.minecraft.dead_horn_coral": "Үхсэн эвэр шүр",
  "block.minecraft.dead_horn_coral_block": "Үхсэн эвэр шүрэн блок",
  "block.minecraft.dead_horn_coral_fan": "Үхсэн эвэр шүрэн дэвүүр",
  "block.minecraft.dead_horn_coral_wall_fan": "Үхсэн эвэр шүрэн дэвүүр хананд",
  "block.minecraft.dead_tube_coral": "Үхсэн хоолой шүр",
  "block.minecraft.dead_tube_coral_block": "Үхсэн хоолой шүрэн блок",
  "block.minecraft.dead_tube_coral_fan": "Үхсэн хоолой шүрэн дэвүүр",
  "block.minecraft.dead_tube_coral_wall_fan": "Үхсэн хоолой хананы шүр",
  "block.minecraft.decorated_pot": "Чимэглэсэн ваар",
  "block.minecraft.deepslate": "Гүний занар",
  "block.minecraft.deepslate_brick_slab": "Гүний занар тоосгон хавтан",
  "block.minecraft.deepslate_brick_stairs": "Гүний занар тоосгон шат",
  "block.minecraft.deepslate_brick_wall": "Гүний занар тоосгон хана",
  "block.minecraft.deepslate_bricks": "Гүний занар тоосго",
  "block.minecraft.deepslate_coal_ore": "Гүний занар дахь нүүрсний хүдэр",
  "block.minecraft.deepslate_copper_ore": "Гүний занар дахь зэсийн хүдэр",
  "block.minecraft.deepslate_diamond_ore": "Гүний занар дахь амлаасын хүдэр",
  "block.minecraft.deepslate_emerald_ore": "Гүний занар дахь маргадын хүдэр",
  "block.minecraft.deepslate_gold_ore": "Гүний занар дахь алтны хүдэр",
  "block.minecraft.deepslate_iron_ore": "Гүний занар дахь төмрийн хүдэр",
  "block.minecraft.deepslate_lapis_ore": "Гүний занар дахь номин чулууны хүдэр",
  "block.minecraft.deepslate_redstone_ore": "Гүний занар дахь улаан чулууны хүдэр",
  "block.minecraft.deepslate_tile_slab": "Дөрвөлжин хээтэй гүний занар хавтан",
  "block.minecraft.deepslate_tile_stairs": "Дөрвөлжин хээтэй гүний занар шат",
  "block.minecraft.deepslate_tile_wall": "Дөрвөлжин хээтэй гүний занар хана",
  "block.minecraft.deepslate_tiles": "Дөрвөлжин хээтэй гүний занар",
  "block.minecraft.detector_rail": "Илрүүлэгч төмөр зам",
  "block.minecraft.diamond_block": "Алмаас эрдэнэн блок",
  "block.minecraft.diamond_ore": "Алмаасын хүдэр",
  "block.minecraft.diorite": "Диорит",
  "block.minecraft.diorite_slab": "Диорит хавтан",
  "block.minecraft.diorite_stairs": "Диорит шат",
  "block.minecraft.diorite_wall": "Диорит хана",
  "block.minecraft.dirt": "Шороо",
  "block.minecraft.dirt_path": "Шороон зам",
  "block.minecraft.dispenser": "Харвагч",
  "block.minecraft.dragon_egg": "Луугийн өндөг",
  "block.minecraft.dragon_head": "Лууны толгой",
  "block.minecraft.dragon_wall_head": "Лууны толгой хананд",
  "block.minecraft.dried_ghast": "Хатсан гаст",
  "block.minecraft.dried_kelp_block": "Хатаасан замган блок",
  "block.minecraft.dripstone_block": "Бана блок",
  "block.minecraft.dropper": "Унагагч",
  "block.minecraft.emerald_block": "Маргад блок",
  "block.minecraft.emerald_ore": "Маргадын хүдэр",
  "block.minecraft.enchanting_table": "Ид шидийн ширээ",
  "block.minecraft.end_gateway": "Ээндийн гарц",
  "block.minecraft.end_portal": "Ээндийн хаалга",
  "block.minecraft.end_portal_frame": "Ээндийн хаалганы хүрээ",
  "block.minecraft.end_rod": "Ээндийн савх",
  "block.minecraft.end_stone": "Ээндийн чулуу",
  "block.minecraft.end_stone_brick_slab": "Ээндийн чулуун тоосгон хавтан",
  "block.minecraft.end_stone_brick_stairs": "Ээндийн чулуун тоосгон шат",
  "block.minecraft.end_stone_brick_wall": "Ээндийн чулуун тоосгон хана",
  "block.minecraft.end_stone_bricks": "Ээндийн чулуун тоосго",
  "block.minecraft.ender_chest": "Ээндэрийн авдар",
  "block.minecraft.exposed_chiseled_copper": "Өгөршсөн сийлсэн зэс",
  "block.minecraft.exposed_copper": "Өгөршсөн зэс",
  "block.minecraft.exposed_copper_bars": "Өгөршсөн зэс тор",
  "block.minecraft.exposed_copper_bulb": "Өгөршсөн зэс гэрэл",
  "block.minecraft.exposed_copper_chain": "Өгөршсөн зэс гинж",
  "block.minecraft.exposed_copper_chest": "Өгөршсөн зэс авдар",
  "block.minecraft.exposed_copper_door": "Өгөршсөн зэс хаалга",
  "block.minecraft.exposed_copper_golem_statue": "Өгөршсөн зэс големын хөшөө",
  "block.minecraft.exposed_copper_grate": "Өгөршсөн зэс сараалж",
  "block.minecraft.exposed_copper_lantern": "Өгөршсөн зэс дэнлүү",
  "block.minecraft.exposed_copper_trapdoor": "Өгөршсөн зэс сөхдөг хаалга",
  "block.minecraft.exposed_cut_copper": "Өгөршсөн зүсмэл зэс",
  "block.minecraft.exposed_cut_copper_slab": "Өгөршсөн зүсмэл зэс хавтан",
  "block.minecraft.exposed_cut_copper_stairs": "Өгөршсөн зүсмэл зэс шат",
  "block.minecraft.exposed_lightning_rod": "Өгөршсөн аянга газардуулагч",
  "block.minecraft.farmland": "Хагалсан газар",
  "block.minecraft.fern": "Ойм",
  "block.minecraft.fire": "Гал",
  "block.minecraft.fire_coral": "Гал шүр",
  "block.minecraft.fire_coral_block": "Гал шүрэн блок",
  "block.minecraft.fire_coral_fan": "Гал шүрэн дэвүүр",
  "block.minecraft.fire_coral_wall_fan": "Гал шүрэн дэвүүр хананд",
  "block.minecraft.firefly_bush": "Гэрэлт цохны бут",
  "block.minecraft.fletching_table": "Нум сум урлах ширээ",
  "block.minecraft.flower_pot": "Цэцгийн сав",
  "block.minecraft.flowering_azalea": "Цэцэглэсэн азалиа",
  "block.minecraft.flowering_azalea_leaves": "Цэцэглэсэн азалиан навч",
  "block.minecraft.frogspawn": "Мэлхийн түрс",
  "block.minecraft.frosted_ice": "Царцсан мөс",
  "block.minecraft.furnace": "Зуух",
  "block.minecraft.gilded_blackstone": "Алтадсан хар чулуу",
  "block.minecraft.glass": "Шил",
  "block.minecraft.glass_pane": "Шилэн хавтан",
  "block.minecraft.glow_lichen": "Гэрэлт хаг",
  "block.minecraft.glowstone": "Гэрэлт чулуу",
  "block.minecraft.gold_block": "Алтан блок",
  "block.minecraft.gold_ore": "Алтны хүдэр",
  "block.minecraft.golden_dandelion": "Алтан багваахай",
  "block.minecraft.granite": "Боржин",
  "block.minecraft.granite_slab": "Боржин хавтан",
  "block.minecraft.granite_stairs": "Боржин шат",
  "block.minecraft.granite_wall": "Боржин хана",
  "block.minecraft.grass": "Өвс",
  "block.minecraft.grass_block": "Өвстэй хөрс",
  "block.minecraft.gravel": "Хайрга",
  "block.minecraft.gray_banner": "Саарал туг",
  "block.minecraft.gray_bed": "Саарал ор",
  "block.minecraft.gray_candle": "Саарал лаа",
  "block.minecraft.gray_candle_cake": "Саарал лаатай бялуу",
  "block.minecraft.gray_carpet": "Саарал хивс",
  "block.minecraft.gray_concrete": "Саарал бетон",
  "block.minecraft.gray_concrete_powder": "Саарал нунтаг бетон",
  "block.minecraft.gray_glazed_terracotta": "Саарал хээтэй шавар",
  "block.minecraft.gray_shulker_box": "Саарал шалкер хайрцаг",
  "block.minecraft.gray_stained_glass": "Саарал будагтай шил",
  "block.minecraft.gray_stained_glass_pane": "Саарал будагтай шилэн хавтан",
  "block.minecraft.gray_terracotta": "Саарал хатуу шавар",
  "block.minecraft.gray_wool": "Саарал ноос",
  "block.minecraft.green_banner": "Ногоон туг",
  "block.minecraft.green_bed": "Ногоон ор",
  "block.minecraft.green_candle": "Ногоон лаа",
  "block.minecraft.green_candle_cake": "Ногоон лаатай бялуу",
  "block.minecraft.green_carpet": "Ногоон хивс",
  "block.minecraft.green_concrete": "Ногоон бетон",
  "block.minecraft.green_concrete_powder": "Ногоон нунтаг бетон",
  "block.minecraft.green_glazed_terracotta": "Ногоон хээтэй шавар",
  "block.minecraft.green_shulker_box": "Ногоон шалкер хайрцаг",
  "block.minecraft.green_stained_glass": "Ногоон будагтай шил",
  "block.minecraft.green_stained_glass_pane": "Ногоон будагтай шилэн хавтан",
  "block.minecraft.green_terracotta": "Ногоон хатуу шавар",
  "block.minecraft.green_wool": "Ногоон ноос",
  "block.minecraft.grindstone": "Билүү",
  "block.minecraft.hanging_roots": "Унжиж буй үндэс",
  "block.minecraft.hay_block": "Бухал өвс",
  "block.minecraft.heavy_core": "Хүнд цөм",
  "block.minecraft.heavy_weighted_pressure_plate": "Хүнд жингийн даралтын хавтан",
  "block.minecraft.honey_block": "Зөгийн балан блок",
  "block.minecraft.honeycomb_block": "Зөгийн сархинаган блок",
  "block.minecraft.hopper": "Гулгуулагч",
  "block.minecraft.horn_coral": "Эвэр шүр",
  "block.minecraft.horn_coral_block": "Эвэр шүрэн блок",
  "block.minecraft.horn_coral_fan": "Эвэр шүрэн дэвүүр",
  "block.minecraft.horn_coral_wall_fan": "Эвэр шүрэн дэвүүр хананд",
  "block.minecraft.ice": "Мөс",
  "block.minecraft.infested_chiseled_stone_bricks": "Язганах сийлсэн чулуун тоосго",
  "block.minecraft.infested_cobblestone": "Язганах хагархай чулуу",
  "block.minecraft.infested_cracked_stone_bricks": "Язганах хөвдтэй чулуун тоосго",
  "block.minecraft.infested_deepslate": "Өтсөн гүний занар",
  "block.minecraft.infested_mossy_stone_bricks": "Язганах хөвдтэй хагархай чулуу",
  "block.minecraft.infested_stone": "Өтсөн чулуу",
  "block.minecraft.infested_stone_bricks": "Язганах чулуун тоосго",
  "block.minecraft.iron_bars": "Төмөр тор",
  "block.minecraft.iron_block": "Төмөр блок",
  "block.minecraft.iron_chain": "Төмөр гинж",
  "block.minecraft.iron_door": "Төмөр хаалга",
  "block.minecraft.iron_ore": "Төмрийн хүдэр",
  "block.minecraft.iron_trapdoor": "Төмөр сөхдөг хаалга",
  "block.minecraft.jack_o_lantern": "Гэрэлт хулуу",
  "block.minecraft.jigsaw": "Эвлүүлдэг блок",
  "block.minecraft.jukebox": "Пянз тоглуулагч",
  "block.minecraft.jungle_button": "Ширэнгэн ойн модон товч",
  "block.minecraft.jungle_door": "Ширэнгэн ойн модон хаалга",
  "block.minecraft.jungle_fence": "Ширэнгэн ойн модон хашаа",
  "block.minecraft.jungle_fence_gate": "Ширэнгэн ойн модон хашааны хаалга",
  "block.minecraft.jungle_hanging_sign": "Ширэнгэн ойн модон дүүжилдэг самбар",
  "block.minecraft.jungle_leaves": "Ширэнгэн ойн модны навч",
  "block.minecraft.jungle_log": "Ширэнгэн ойн модон дүнз",
  "block.minecraft.jungle_planks": "Ширэнгэн ойн модон банз",
  "block.minecraft.jungle_pressure_plate": "Ширэнгэн ойн модон даралтын хавтан",
  "block.minecraft.jungle_sapling": "Зулзаган ширэнгэн ойн мод",
  "block.minecraft.jungle_shelf": "Ширэнгэн ойн модон тавиур",
  "block.minecraft.jungle_sign": "Ширэнгэн ойн модон самбар",
  "block.minecraft.jungle_slab": "Ширэнгэн ойн модон хавтан",
  "block.minecraft.jungle_stairs": "Ширэнгэн ойн модон шат",
  "block.minecraft.jungle_trapdoor": "Ширэнгэн ойн модон сөхдөг хаалга",
  "block.minecraft.jungle_wall_hanging_sign": "Ширэнгэн ойн модон хананаас дүүжилдэг самбар",
  "block.minecraft.jungle_wall_sign": "Ширэнгэн ойн модон ханын самбар",
  "block.minecraft.jungle_wood": "Ширэнгэн ойн мод",
  "block.minecraft.kelp": "Замаг",
  "block.minecraft.kelp_plant": "Замагны иш",
  "block.minecraft.ladder": "Босоо шат",
  "block.minecraft.lantern": "Дэнлүү",
  "block.minecraft.lapis_block": "Номин чулуун блок",
  "block.minecraft.lapis_ore": "Номин чулууны хүдэр",
  "block.minecraft.large_amethyst_bud": "Ягаан болрын том нахиа",
  "block.minecraft.large_fern": "Том ойм",
  "block.minecraft.lava": "Хайлмаг",
  "block.minecraft.lava_cauldron": "Хайлмагтай тогоо",
  "block.minecraft.leaf_litter": "Унасан навч",
  "block.minecraft.lectern": "Индэр",
  "block.minecraft.lever": "Хөшүүрэг",
  "block.minecraft.light": "Гэрэл",
  "block.minecraft.light_blue_banner": "Цэнхэр туг",
  "block.minecraft.light_blue_bed": "Цэнхэр ор",
  "block.minecraft.light_blue_candle": "Цэнхэр лаа",
  "block.minecraft.light_blue_candle_cake": "Цэнхэр лаатай бялуу",
  "block.minecraft.light_blue_carpet": "Цэнхэр хивс",
  "block.minecraft.light_blue_concrete": "Цэнхэр бетон",
  "block.minecraft.light_blue_concrete_powder": "Цэнхэр нунтаг бетон",
  "block.minecraft.light_blue_glazed_terracotta": "Цэнхэр хээтэй шавар",
  "block.minecraft.light_blue_shulker_box": "Цэнхэр шалкер хайрцаг",
  "block.minecraft.light_blue_stained_glass": "Цэнхэр будагтай шил",
  "block.minecraft.light_blue_stained_glass_pane": "Цэнхэр будагтай шилэн хавтан",
  "block.minecraft.light_blue_terracotta": "Цэнхэр хатуу шавар",
  "block.minecraft.light_blue_wool": "Цэнхэр ноос",
  "block.minecraft.light_gray_banner": "Цайвар саарал туг",
  "block.minecraft.light_gray_bed": "Цайвар саарал ор",
  "block.minecraft.light_gray_candle": "Цайвар саарал лаа",
  "block.minecraft.light_gray_candle_cake": "Цайвар саарал лаатай бялуу",
  "block.minecraft.light_gray_carpet": "Цайвар саарал хивс",
  "block.minecraft.light_gray_concrete": "Цайвар саарал бетон",
  "block.minecraft.light_gray_concrete_powder": "Цайвар саарал нунтаг бетон",
  "block.minecraft.light_gray_glazed_terracotta": "Цайвар саарал хээтэй шавар",
  "block.minecraft.light_gray_shulker_box": "Цайвар саарал шалкер хайрцаг",
  "block.minecraft.light_gray_stained_glass": "Цайвар саарал будагтай шил",
  "block.minecraft.light_gray_stained_glass_pane": "Цайвар саарал будагтай шилэн хавтан",
  "block.minecraft.light_gray_terracotta": "Цайвар саарал хатуу шавар",
  "block.minecraft.light_gray_wool": "Цайвар саарал ноос",
  "block.minecraft.light_weighted_pressure_plate": "Хөнгөн жингийн даралтын хавтан",
  "block.minecraft.lightning_rod": "Аянга газардуулагч",
  "block.minecraft.lilac": "Голт бор",
  "block.minecraft.lily_of_the_valley": "Хөндийн сараана",
  "block.minecraft.lily_pad": "Сарааны дэлбээ",
  "block.minecraft.lime_banner": "Цайвар ногоон туг",
  "block.minecraft.lime_bed": "Цайвар ногоон ор",
  "block.minecraft.lime_candle": "Цайвар ногоон лаа",
  "block.minecraft.lime_candle_cake": "Цайвар ногоон лаатай бялуу",
  "block.minecraft.lime_carpet": "Цайвар ногоон хивс",
  "block.minecraft.lime_concrete": "Цайвар ногоон бетон",
  "block.minecraft.lime_concrete_powder": "Цайвар ногоон нунтаг бетон",
  "block.minecraft.lime_glazed_terracotta": "Цайвар ногоон хээтэй шавар",
  "block.minecraft.lime_shulker_box": "Цайвар ногоон шалкер хайрцаг",
  "block.minecraft.lime_stained_glass": "Цайвар ногоон будагтай шил",
  "block.minecraft.lime_stained_glass_pane": "Цайвар ногоон будагтай шилэн хавтан",
  "block.minecraft.lime_terracotta": "Цайвар ногоон хатуу шавар",
  "block.minecraft.lime_wool": "Цайвар ногоон ноос",
  "block.minecraft.lodestone": "Чиглүүлэгч чулуу",
  "block.minecraft.loom": "Нэхмэлийн машин",
  "block.minecraft.magenta_banner": "Ягаан туг",
  "block.minecraft.magenta_bed": "Ягаан ор",
  "block.minecraft.magenta_candle": "Ягаан лаа",
  "block.minecraft.magenta_candle_cake": "Ягаан лаатай бялуу",
  "block.minecraft.magenta_carpet": "Ягаан хивс",
  "block.minecraft.magenta_concrete": "Ягаан бетон",
  "block.minecraft.magenta_concrete_powder": "Ягаан нунтаг бетон",
  "block.minecraft.magenta_glazed_terracotta": "Ягаан хээтэй шавар",
  "block.minecraft.magenta_shulker_box": "Ягаан шалкер хайрцаг",
  "block.minecraft.magenta_stained_glass": "Ягаан будагтай шил",
  "block.minecraft.magenta_stained_glass_pane": "Ягаан будагтай шилэн хавтан",
  "block.minecraft.magenta_terracotta": "Ягаан хатуу шавар",
  "block.minecraft.magenta_wool": "Ягаан ноос",
  "block.minecraft.magma_block": "Хайлмагтай чулуу",
  "block.minecraft.mangrove_button": "Мангро модон товч",
  "block.minecraft.mangrove_door": "Мангро модон хаалга",
  "block.minecraft.mangrove_fence": "Мангро модон хашаа",
  "block.minecraft.mangrove_fence_gate": "Мангро модон хашааны хаалга",
  "block.minecraft.mangrove_hanging_sign": "Мангро модон дүүжилдэг самбар",
  "block.minecraft.mangrove_leaves": "Мангро модны навч",
  "block.minecraft.mangrove_log": "Мангро модон дүнз",
  "block.minecraft.mangrove_planks": "Мангро модон банз",
  "block.minecraft.mangrove_pressure_plate": "Мангро модон даралтын хавтан",
  "block.minecraft.mangrove_propagule": "Мангро нахиа",
  "block.minecraft.mangrove_roots": "Мангро модны үндэс",
  "block.minecraft.mangrove_shelf": "Мангро модон тавиур",
  "block.minecraft.mangrove_sign": "Мангро модон самбар",
  "block.minecraft.mangrove_slab": "Мангро модон хавтан",
  "block.minecraft.mangrove_stairs": "Мангро модон шат",
  "block.minecraft.mangrove_trapdoor": "Мангро модон сөхдөг хаалга",
  "block.minecraft.mangrove_wall_hanging_sign": "Мангро модон хананаас дүүжилдэг самбар",
  "block.minecraft.mangrove_wall_sign": "Мангро модон ханын самбар",
  "block.minecraft.mangrove_wood": "Мангро мод",
  "block.minecraft.medium_amethyst_bud": "Ягаан болрын жижиг нахиа",
  "block.minecraft.melon": "Тарвас",
  "block.minecraft.melon_stem": "Тарвасны иш",
  "block.minecraft.moss_block": "Хөвдөн блок",
  "block.minecraft.moss_carpet": "Хөвдөн дэвсгэр",
  "block.minecraft.mossy_cobblestone": "Хөвдтэй хагархай чулуу",
  "block.minecraft.mossy_cobblestone_slab": "Хөвдтэй хагархай чулуун хавтан",
  "block.minecraft.mossy_cobblestone_stairs": "Хөвдтэй хагархай чулуун шат",
  "block.minecraft.mossy_cobblestone_wall": "Хөвдтэй хагархай чулуун хана",
  "block.minecraft.mossy_stone_brick_slab": "Хөвдтэй чулуун тоосгон хавтан",
  "block.minecraft.mossy_stone_brick_stairs": "Хөвдтэй чулуун тоосгон шат",
  "block.minecraft.mossy_stone_brick_wall": "Хөвдтэй чулуун тоосгон хана",
  "block.minecraft.mossy_stone_bricks": "Хөвдтэй чулуун тоосго",
  "block.minecraft.moving_piston": "Хөдөлж буй түлхэгч",
  "block.minecraft.mud": "Шавх",
  "block.minecraft.mud_brick_slab": "Шавх тоосгон хавтан",
  "block.minecraft.mud_brick_stairs": "Шавх тоосгон шат",
  "block.minecraft.mud_brick_wall": "Шавх тоосгон хана",
  "block.minecraft.mud_bricks": "Шавх тоосго",
  "block.minecraft.muddy_mangrove_roots": "Шаварлаг мангро модны үндэс",
  "block.minecraft.mushroom_stem": "Мөөгний иш",
  "block.minecraft.mycelium": "Мөөгний хөрс",
  "block.minecraft.nether_brick_fence": "Тамын тоосгон хашаа",
  "block.minecraft.nether_brick_slab": "Тамын тоосгон хавтан",
  "block.minecraft.nether_brick_stairs": "Тамын тоосгон шат",
  "block.minecraft.nether_brick_wall": "Тамын тоосгон хана",
  "block.minecraft.nether_bricks": "Тамын тоосго",
  "block.minecraft.nether_gold_ore": "Тамын алтны хүдэр",
  "block.minecraft.nether_portal": "Тамын хаалга",
  "block.minecraft.nether_quartz_ore": "Кварцын хүдэр",
  "block.minecraft.nether_sprouts": "Тамын нахиа",
  "block.minecraft.nether_wart": "Тамын үү",
  "block.minecraft.nether_wart_block": "Тамын үүн блок",
  "block.minecraft.netherite_block": "Недерит блок",
  "block.minecraft.netherrack": "Тамын чулуу",
  "block.minecraft.note_block": "Хөгжим",
  "block.minecraft.oak_button": "Царс модон товч",
  "block.minecraft.oak_door": "Царс модон хаалга",
  "block.minecraft.oak_fence": "Царс модон хашаа",
  "block.minecraft.oak_fence_gate": "Царс модон хашааны хаалга",
  "block.minecraft.oak_hanging_sign": "Царс модон дүүжилдэг самбар",
  "block.minecraft.oak_leaves": "Царс модны навч",
  "block.minecraft.oak_log": "Царс модон дүнз",
  "block.minecraft.oak_planks": "Царс модон банз",
  "block.minecraft.oak_pressure_plate": "Царс модон даралтын хавтан",
  "block.minecraft.oak_sapling": "Зулзаган царс мод",
  "block.minecraft.oak_shelf": "Царс модон тавиур",
  "block.minecraft.oak_sign": "Царс модон самбар",
  "block.minecraft.oak_slab": "Царс модон хавтан",
  "block.minecraft.oak_stairs": "Царс модон шат",
  "block.minecraft.oak_trapdoor": "Царс модон сөхдөг хаалга",
  "block.minecraft.oak_wall_hanging_sign": "Царс модон хананаас дүүжилдэг самбар",
  "block.minecraft.oak_wall_sign": "Царс модон ханын самбар",
  "block.minecraft.oak_wood": "Царс мод",
  "block.minecraft.observer": "Ажиглагч",
  "block.minecraft.obsidian": "Хар шил",
  "block.minecraft.ochre_froglight": "Шаргал мэлхийн гэрэл",
  "block.minecraft.ominous_banner": "Муу ёрын туг",
  "block.minecraft.open_eyeblossom": "Дэлгэрсэн гэрэлт нүдэн",
  "block.minecraft.orange_banner": "Улбар шар туг",
  "block.minecraft.orange_bed": "Улбар шар ор",
  "block.minecraft.orange_candle": "Улбар шар лаа",
  "block.minecraft.orange_candle_cake": "Улбар шар лаатай бялуу",
  "block.minecraft.orange_carpet": "Улбар шар хивс",
  "block.minecraft.orange_concrete": "Улбар шар бетон",
  "block.minecraft.orange_concrete_powder": "Улбар шар нунтаг бетон",
  "block.minecraft.orange_glazed_terracotta": "Улбар шар хээтэй шавар",
  "block.minecraft.orange_shulker_box": "Улбар шар шалкер хайрцаг",
  "block.minecraft.orange_stained_glass": "Улбар шар будагтай шил",
  "block.minecraft.orange_stained_glass_pane": "Улбар шар будагтай шилэн хавтан",
  "block.minecraft.orange_terracotta": "Улбар шар хатуу шавар",
  "block.minecraft.orange_tulip": "Улбар шар алтанзул",
  "block.minecraft.orange_wool": "Улбар шар ноос",
  "block.minecraft.oxeye_daisy": "Хонин нүд",
  "block.minecraft.oxidized_chiseled_copper": "Бүрэн исэлдсэн сийлсэн зэс",
  "block.minecraft.oxidized_copper": "Бүрэн исэлдсэн зэс",
  "block.minecraft.oxidized_copper_bars": "Бүрэн исэлдсэн зэс тор",
  "block.minecraft.oxidized_copper_bulb": "Бүрэн исэлдсэн зэс гэрэл",
  "block.minecraft.oxidized_copper_chain": "Бүрэн исэлдсэн зэс гинж",
  "block.minecraft.oxidized_copper_chest": "Бүрэн исэлдсэн зэс авдар",
  "block.minecraft.oxidized_copper_door": "Бүрэн исэлдсэн зэс хаалга",
  "block.minecraft.oxidized_copper_golem_statue": "Бүрэн исэлдсэн зэс големын хөшөө",
  "block.minecraft.oxidized_copper_grate": "Бүрэн исэлдсэн зэс сараалж",
  "block.minecraft.oxidized_copper_lantern": "Бүрэн исэлдсэн зэс дэнлүү",
  "block.minecraft.oxidized_copper_trapdoor": "Бүрэн исэлдсэн зэс сөхдөг хаалга",
  "block.minecraft.oxidized_cut_copper": "Бүрэн исэлдсэн зүсмэл зэс",
  "block.minecraft.oxidized_cut_copper_slab": "Бүрэн исэлдсэн зүсмэл зэс хавтан",
  "block.minecraft.oxidized_cut_copper_stairs": "Бүрэн исэлдсэн зүсмэл зэс шат",
  "block.minecraft.oxidized_lightning_rod": "Бүрэн исэлдсэн аянга газардуулагч",
  "block.minecraft.packed_ice": "Нягт мөс",
  "block.minecraft.packed_mud": "Багцалсан шавх",
  "block.minecraft.pale_hanging_moss": "Унжуу зэвхий хөвд",
  "block.minecraft.pale_moss_block": "Зэвхий хөвдөн блок",
  "block.minecraft.pale_moss_carpet": "Зэвхий хөвдөн дэвсгэр",
  "block.minecraft.pale_oak_button": "Зэвхий царс модон товч",
  "block.minecraft.pale_oak_door": "Зэвхий царс модон хаалга",
  "block.minecraft.pale_oak_fence": "Зэвхий царс модон хашаа",
  "block.minecraft.pale_oak_fence_gate": "Зэвхий царс модон хашааны хаалга",
  "block.minecraft.pale_oak_hanging_sign": "Зэвхий царс модон дүүжилдэг самбар",
  "block.minecraft.pale_oak_leaves": "Зэвхий царс модны навч",
  "block.minecraft.pale_oak_log": "Зэвхий царс модон дүнз",
  "block.minecraft.pale_oak_planks": "Зэвхий царс модон банз",
  "block.minecraft.pale_oak_pressure_plate": "Зэвхий царс модон даралтын хавтан",
  "block.minecraft.pale_oak_sapling": "Зулзаган зэвхий царс мод",
  "block.minecraft.pale_oak_shelf": "Зэвхий царс модон авдар",
  "block.minecraft.pale_oak_sign": "Зэвхий царс модон самбар",
  "block.minecraft.pale_oak_slab": "Зэвхий царс модон хавтан",
  "block.minecraft.pale_oak_stairs": "Зэвхий царс модон шат",
  "block.minecraft.pale_oak_trapdoor": "Зэвхий царс модон сөхдөг хаалга",
  "block.minecraft.pale_oak_wall_hanging_sign": "Зэвхий царс модон хананаас дүүжилдэг самбар",
  "block.minecraft.pale_oak_wall_sign": "Зэвхий царс модон ханын самбар",
  "block.minecraft.pale_oak_wood": "Зэвхий царс мод",
  "block.minecraft.pearlescent_froglight": "Сувдан мэлхийн гэрэл",
  "block.minecraft.peony": "Цээнэ",
  "block.minecraft.petrified_oak_slab": "Чулуужсан царс модон хавтан",
  "block.minecraft.piglin_head": "Пиглиний толгой",
  "block.minecraft.piglin_wall_head": "Пиглиний толгой хананд",
  "block.minecraft.pink_banner": "Цайвар ягаан туг",
  "block.minecraft.pink_bed": "Ягаан ор",
  "block.minecraft.pink_candle": "Цайвар ягаан лаа",
  "block.minecraft.pink_candle_cake": "Цайвар ягаан лаатай бялуу",
  "block.minecraft.pink_carpet": "Цайвар ягаан хивс",
  "block.minecraft.pink_concrete": "Цайвар ягаан бетон",
  "block.minecraft.pink_concrete_powder": "Цайвар ягаан нунтаг бетон",
  "block.minecraft.pink_glazed_terracotta": "Цайвар ягаан хээтэй шавар",
  "block.minecraft.pink_petals": "Ягаан дэлбээ",
  "block.minecraft.pink_shulker_box": "Цайвар ягаан шалкер хайрцаг",
  "block.minecraft.pink_stained_glass": "Цайвар ягаан будагтай шил",
  "block.minecraft.pink_stained_glass_pane": "Цайвар ягаан будагтай шилэн хавтан",
  "block.minecraft.pink_terracotta": "Цайвар ягаан хатуу шавар",
  "block.minecraft.pink_tulip": "Ягаан алтанзул",
  "block.minecraft.pink_wool": "Цайвар ягаан ноос",
  "block.minecraft.piston": "Түлхэгч",
  "block.minecraft.piston_head": "Түлхэгчийн толгой",
  "block.minecraft.pitcher_crop": "Саррацени ургац",
  "block.minecraft.pitcher_plant": "Саррацени",
  "block.minecraft.player_head": "Тоглогчийн толгой",
  "block.minecraft.player_head.named": "%s-н толгой",
  "block.minecraft.player_wall_head": "Тоглогчийн толгой хананд",
  "block.minecraft.podzol": "Шилмүүст хөрс",
  "block.minecraft.pointed_dripstone": "Бана",
  "block.minecraft.polished_andesite": "Өнгөлсөн андезит",
  "block.minecraft.polished_andesite_slab": "Өнгөлсөн андезит хавтан",
  "block.minecraft.polished_andesite_stairs": "Өнгөлсөн андезит шат",
  "block.minecraft.polished_basalt": "Өнгөлсөн базальт",
  "block.minecraft.polished_blackstone": "Өнгөлсөн хар чулуу",
  "block.minecraft.polished_blackstone_brick_slab": "Өнгөлсөн хар чулуун тоосгон хавтан",
  "block.minecraft.polished_blackstone_brick_stairs": "Өнгөлсөн хар чулуун тоосгон шат",
  "block.minecraft.polished_blackstone_brick_wall": "Өнгөлсөн хар чулуун тоосгон хана",
  "block.minecraft.polished_blackstone_bricks": "Өнгөлсөн хар чулуун тоосго",
  "block.minecraft.polished_blackstone_button": "Өнгөлсөн хар чулуун товч",
  "block.minecraft.polished_blackstone_pressure_plate": "Өнгөлсөн хар чулуун даралтын хавтан",
  "block.minecraft.polished_blackstone_slab": "Өнгөлсөн хар чулуун хавтан",
  "block.minecraft.polished_blackstone_stairs": "Өнгөлсөн хар чулуун шат",
  "block.minecraft.polished_blackstone_wall": "Өнгөлсөн хар чулуун хана",
  "block.minecraft.polished_deepslate": "Гөлгөр гүний занар",
  "block.minecraft.polished_deepslate_slab": "Гөлгөр гүний занар хавтан",
  "block.minecraft.polished_deepslate_stairs": "Гөлгөр гүний занар шат",
  "block.minecraft.polished_deepslate_wall": "Гөлгөр гүний занар хана",
  "block.minecraft.polished_diorite": "Өнгөлсөн диорит",
  "block.minecraft.polished_diorite_slab": "Өнгөлсөн диорит хавтан",
  "block.minecraft.polished_diorite_stairs": "Өнгөлсөн диорит шат",
  "block.minecraft.polished_granite": "Өнгөлсөн боржин",
  "block.minecraft.polished_granite_slab": "Өнгөлсөн боржин хавтан",
  "block.minecraft.polished_granite_stairs": "Өнгөлсөн боржин шат",
  "block.minecraft.polished_tuff": "Өнгөлсөн туф",
  "block.minecraft.polished_tuff_slab": "Өнгөлсөн туф хавтан",
  "block.minecraft.polished_tuff_stairs": "Өнгөлсөн туф шат",
  "block.minecraft.polished_tuff_wall": "Өнгөлсөн туф хана",
  "block.minecraft.poppy": "Намуу",
  "block.minecraft.potatoes": "Төмс",
  "block.minecraft.potted_acacia_sapling": "Ваартай зулзаган хуайс мод",
  "block.minecraft.potted_allium": "Ваартай халиар",
  "block.minecraft.potted_azalea_bush": "Ваартай азалиа",
  "block.minecraft.potted_azure_bluet": "Ваартай хонгорзул",
  "block.minecraft.potted_bamboo": "Ваартай хулс",
  "block.minecraft.potted_birch_sapling": "Ваартай зулзаган хус мод",
  "block.minecraft.potted_blue_orchid": "Ваартай хөх цахирмаа",
  "block.minecraft.potted_brown_mushroom": "Ваартай бор мөөг",
  "block.minecraft.potted_cactus": "Ваартай кактус",
  "block.minecraft.potted_cherry_sapling": "Ваартай зулзаган интоорын мод",
  "block.minecraft.potted_closed_eyeblossom": "Ваартай хумисан гэрэлт нүдэн",
  "block.minecraft.potted_cornflower": "Ваартай хөх хонгорзул",
  "block.minecraft.potted_crimson_fungus": "Ваартай нөжит мөөг",
  "block.minecraft.potted_crimson_roots": "Ваартай нөжит ургамал",
  "block.minecraft.potted_dandelion": "Ваартай багваахай",
  "block.minecraft.potted_dark_oak_sapling": "Ваартай зулзаган хар царс мод",
  "block.minecraft.potted_dead_bush": "Ваартай үхсэн бут",
  "block.minecraft.potted_fern": "Ваартай ойм",
  "block.minecraft.potted_flowering_azalea_bush": "Ваартай цэцэглэсэн азалиа",
  "block.minecraft.potted_golden_dandelion": "Ваартай алтан багваахай",
  "block.minecraft.potted_jungle_sapling": "Ваартай зулзаган ширэнгэн ойн мод",
  "block.minecraft.potted_lily_of_the_valley": "Ваартай хөндийн сараана",
  "block.minecraft.potted_mangrove_propagule": "Ваартай мангро нахиа",
  "block.minecraft.potted_oak_sapling": "Ваартай зулзаган царс мод",
  "block.minecraft.potted_open_eyeblossom": "Ваартай дэлгэрсэн гэрэлт нүдэн",
  "block.minecraft.potted_orange_tulip": "Ваартай улбар шар алтанзул",
  "block.minecraft.potted_oxeye_daisy": "Ваартай хонин нүд",
  "block.minecraft.potted_pale_oak_sapling": "Ваартай зулзаган зэвхий царс мод",
  "block.minecraft.potted_pink_tulip": "Ваартай ягаан алтанзул",
  "block.minecraft.potted_poppy": "Ваартай намуу",
  "block.minecraft.potted_red_mushroom": "Ваартай улаан мөөг",
  "block.minecraft.potted_red_tulip": "Ваартай улаан алтанзул",
  "block.minecraft.potted_spruce_sapling": "Ваартай зулзаган гацуур мод",
  "block.minecraft.potted_torchflower": "Ваартай бамбар цэцэг",
  "block.minecraft.potted_warped_fungus": "Ваартай гажуудсан мөөг",
  "block.minecraft.potted_warped_roots": "Ваартай гажуудсан ургамал",
  "block.minecraft.potted_white_tulip": "Ваартай цагаан алтанзул",
  "block.minecraft.potted_wither_rose": "Ваартай витерийн сарнай",
  "block.minecraft.powder_snow": "Сэвсгэр цас",
  "block.minecraft.powder_snow_cauldron": "Сэвсгэр цастай тогоо",
  "block.minecraft.powered_rail": "Хүчжүүлсэн төмөр зам",
  "block.minecraft.prismarine": "Присмарин",
  "block.minecraft.prismarine_brick_slab": "Присмарин тоосгон хавтан",
  "block.minecraft.prismarine_brick_stairs": "Присмарин тоосгон шат",
  "block.minecraft.prismarine_bricks": "Присмарин тоосго",
  "block.minecraft.prismarine_slab": "Присмарин хавтан",
  "block.minecraft.prismarine_stairs": "Присмарин шат",
  "block.minecraft.prismarine_wall": "Присмарин хана",
  "block.minecraft.pumpkin": "Хулуу",
  "block.minecraft.pumpkin_stem": "Хулууны иш",
  "block.minecraft.purple_banner": "Нил ягаан туг",
  "block.minecraft.purple_bed": "Нил ягаан ор",
  "block.minecraft.purple_candle": "Нил ягаан лаа",
  "block.minecraft.purple_candle_cake": "Нил ягаан лаатай бялуу",
  "block.minecraft.purple_carpet": "Нил ягаан хивс",
  "block.minecraft.purple_concrete": "Нил ягаан бетон",
  "block.minecraft.purple_concrete_powder": "Нил ягаан нунтаг бетон",
  "block.minecraft.purple_glazed_terracotta": "Нил ягаан хээтэй шавар",
  "block.minecraft.purple_shulker_box": "Нил ягаан шалкер хайрцаг",
  "block.minecraft.purple_stained_glass": "Нил ягаан будагтай шил",
  "block.minecraft.purple_stained_glass_pane": "Нил ягаан будагтай шилэн хавтан",
  "block.minecraft.purple_terracotta": "Нил ягаан хатуу шавар",
  "block.minecraft.purple_wool": "Нил ягаан ноос",
  "block.minecraft.purpur_block": "Пурпур блок",
  "block.minecraft.purpur_pillar": "Пурпур багана",
  "block.minecraft.purpur_slab": "Пурпур хавтан",
  "block.minecraft.purpur_stairs": "Пурпур шат",
  "block.minecraft.quartz_block": "Кварц блок",
  "block.minecraft.quartz_bricks": "Кварц тоосго",
  "block.minecraft.quartz_pillar": "Кварц багана",
  "block.minecraft.quartz_slab": "Кварц хавтан",
  "block.minecraft.quartz_stairs": "Кварц шат",
  "block.minecraft.rail": "Төмөр зам",
  "block.minecraft.raw_copper_block": "Боловсруулаагүй зэс блок",
  "block.minecraft.raw_gold_block": "Боловсруулаагүй алтан блок",
  "block.minecraft.raw_iron_block": "Боловсруулаагүй төмөр блок",
  "block.minecraft.red_banner": "Улаан туг",
  "block.minecraft.red_bed": "Улаан ор",
  "block.minecraft.red_candle": "Улаан лаа",
  "block.minecraft.red_candle_cake": "Улаан лаатай бялуу",
  "block.minecraft.red_carpet": "Улаан хивс",
  "block.minecraft.red_concrete": "Улаан бетон",
  "block.minecraft.red_concrete_powder": "Улаан нунтаг бетон",
  "block.minecraft.red_glazed_terracotta": "Улаан хээтэй шавар",
  "block.minecraft.red_mushroom": "Улаан мөөг",
  "block.minecraft.red_mushroom_block": "Улаан мөөгөн блок",
  "block.minecraft.red_nether_brick_slab": "Улаан тамын тоосгон хавтан",
  "block.minecraft.red_nether_brick_stairs": "Улаан тамын тоосгон шат",
  "block.minecraft.red_nether_brick_wall": "Улаан тамын тоосгон хана",
  "block.minecraft.red_nether_bricks": "Улаан тамын тоосго",
  "block.minecraft.red_sand": "Улаан элс",
  "block.minecraft.red_sandstone": "Улаан элсэн чулуу",
  "block.minecraft.red_sandstone_slab": "Улаан элсэн чулуун хавтан",
  "block.minecraft.red_sandstone_stairs": "Улаан элсэн чулуун шат",
  "block.minecraft.red_sandstone_wall": "Улаан элсэн чулуун хана",
  "block.minecraft.red_shulker_box": "Улаан шалкер хайрцаг",
  "block.minecraft.red_stained_glass": "Улаан будагтай шил",
  "block.minecraft.red_stained_glass_pane": "Улаан будагтай шилэн хавтан",
  "block.minecraft.red_terracotta": "Улаан хатуу шавар",
  "block.minecraft.red_tulip": "Улаан алтанзул",
  "block.minecraft.red_wool": "Улаан ноос",
  "block.minecraft.redstone_block": "Редстоун блок",
  "block.minecraft.redstone_lamp": "Редстоун гэрэл",
  "block.minecraft.redstone_ore": "Редстоуны хүдэр",
  "block.minecraft.redstone_torch": "Редстоун бамбар",
  "block.minecraft.redstone_wall_torch": "Редстоун ханын бамбар",
  "block.minecraft.redstone_wire": "Редстоун утас",
  "block.minecraft.reinforced_deepslate": "Бэхжүүлсэн гүний занар",
  "block.minecraft.repeater": "Редстоун давтагч",
  "block.minecraft.repeating_command_block": "Давталттай тушаалын блок",
  "block.minecraft.resin_block": "Давирхайн блок",
  "block.minecraft.resin_brick_slab": "Давирхайн тоосгон хавтан",
  "block.minecraft.resin_brick_stairs": "Давирхайн тоосгон шат",
  "block.minecraft.resin_brick_wall": "Давирхайн тоосгон хана",
  "block.minecraft.resin_bricks": "Давирхайн тоосгон блок",
  "block.minecraft.resin_clump": "Бөөгнөсөн давирхай",
  "block.minecraft.respawn_anchor": "Дахин төрүүлэх зангуу",
  "block.minecraft.rooted_dirt": "Үндэстэй шороо",
  "block.minecraft.rose_bush": "Сарнайн бут",
  "block.minecraft.sand": "Элс",
  "block.minecraft.sandstone": "Элсэн чулуу",
  "block.minecraft.sandstone_slab": "Элсэн чулуун хавтан",
  "block.minecraft.sandstone_stairs": "Элсэн чулуун шат",
  "block.minecraft.sandstone_wall": "Элсэн чулуун хана",
  "block.minecraft.scaffolding": "Барилгын шат",
  "block.minecraft.sculk": "Скалк",
  "block.minecraft.sculk_catalyst": "Скалк катализатор",
  "block.minecraft.sculk_sensor": "Мэдрэгч скалк",
  "block.minecraft.sculk_shrieker": "Хашхирагч скалк",
  "block.minecraft.sculk_vein": "Скалк судал",
  "block.minecraft.sea_lantern": "Тэнгисийн дэнлүү",
  "block.minecraft.sea_pickle": "Тэнгисийн гэрлэн биет",
  "block.minecraft.seagrass": "Тэнгисийн өвс",
  "block.minecraft.set_spawn": "Дахин төрөх газрыг тохирууллаа",
  "block.minecraft.short_dry_grass": "Хатсан тачирхан өвс",
  "block.minecraft.short_grass": "Тачирхан өвс",
  "block.minecraft.shroomlight": "Мөөгний гэрэл",
  "block.minecraft.shulker_box": "Шалкер хайрцаг",
  "block.minecraft.skeleton_skull": "Гавлын яс",
  "block.minecraft.skeleton_wall_skull": "Гавлын яс хананд",
  "block.minecraft.slime_block": "Салс блок",
  "block.minecraft.small_amethyst_bud": "Ягаан болрын бяцхан нахиа",
  "block.minecraft.small_dripleaf": "Жижиг гоожингор навч",
  "block.minecraft.smithing_table": "Дархны ширээ",
  "block.minecraft.smoker": "Утагч",
  "block.minecraft.smooth_basalt": "Гөлгөр базальт",
  "block.minecraft.smooth_quartz": "Гөлгөр кварц блок",
  "block.minecraft.smooth_quartz_slab": "Гөлгөр кварц хавтан",
  "block.minecraft.smooth_quartz_stairs": "Гөлгөр кварц шат",
  "block.minecraft.smooth_red_sandstone": "Гөлгөр улаан элсэн чулуу",
  "block.minecraft.smooth_red_sandstone_slab": "Гөлгөр улаан элсэн чулуун хавтан",
  "block.minecraft.smooth_red_sandstone_stairs": "Гөлгөр улаан элсэн чулуун шат",
  "block.minecraft.smooth_sandstone": "Гөлгөр элсэн чулуу",
  "block.minecraft.smooth_sandstone_slab": "Гөлгөр элсэн чулуун хавтан",
  "block.minecraft.smooth_sandstone_stairs": "Гөлгөр элсэн чулуун шат",
  "block.minecraft.smooth_stone": "Гөлгөр чулуу",
  "block.minecraft.smooth_stone_slab": "Гөлгөр чулуун хавтан",
  "block.minecraft.sniffer_egg": "Шиншигчийн өндөг",
  "block.minecraft.snow": "Цас",
  "block.minecraft.snow_block": "Цасан блок",
  "block.minecraft.soul_campfire": "Сүнслэг түүдэг гал",
  "block.minecraft.soul_fire": "Сүнслэг гал",
  "block.minecraft.soul_lantern": "Сүнслэг дэнлүү",
  "block.minecraft.soul_sand": "Сүнслэг элс",
  "block.minecraft.soul_soil": "Сүнслэг хөрс",
  "block.minecraft.soul_torch": "Сүнслэг бамбар",
  "block.minecraft.soul_wall_torch": "Сүнслэг хананы бамбар",
  "block.minecraft.spawn.not_valid": "Танд ор эсвэл цэнэглэгдсэн дахин төрөх зангуу байхгүй эсвэл тэдгээр нь саадтай байна",
  "block.minecraft.spawner": "Мангас төрүүлэгч",
  "block.minecraft.spawner.desc1": "Төрүүлэх өндөг ашиглаж:",
  "block.minecraft.spawner.desc2": "Төрүүлэх мобыг тохируулна",
  "block.minecraft.sponge": "Хөвөн",
  "block.minecraft.spore_blossom": "Тоост цэцэг",
  "block.minecraft.spruce_button": "Гацуур модон товч",
  "block.minecraft.spruce_door": "Гацуур модон хаалга",
  "block.minecraft.spruce_fence": "Гацуур модон хашаа",
  "block.minecraft.spruce_fence_gate": "Гацуур модон хашааны хаалга",
  "block.minecraft.spruce_hanging_sign": "Гацуур модон дүүжилдэг самбар",
  "block.minecraft.spruce_leaves": "Гацуур модны шилмүүс",
  "block.minecraft.spruce_log": "Гацуур модон дүнз",
  "block.minecraft.spruce_planks": "Гацуур модон банз",
  "block.minecraft.spruce_pressure_plate": "Гацуур модон даралтын хавтан",
  "block.minecraft.spruce_sapling": "Зулзаган гацуур мод",
  "block.minecraft.spruce_shelf": "Гацуур модон тавиур",
  "block.minecraft.spruce_sign": "Гацуур модон самбар",
  "block.minecraft.spruce_slab": "Гацуур модон хавтан",
  "block.minecraft.spruce_stairs": "Гацуур модон шат",
  "block.minecraft.spruce_trapdoor": "Гацуур модон сөхдөг хаалга",
  "block.minecraft.spruce_wall_hanging_sign": "Гацуур модон хананаас дүүжилдэг самбар",
  "block.minecraft.spruce_wall_sign": "Гацуур модон ханын самбар",
  "block.minecraft.spruce_wood": "Гацуур мод",
  "block.minecraft.sticky_piston": "Наалдамхай түлхэгч",
  "block.minecraft.stone": "Чулуу",
  "block.minecraft.stone_brick_slab": "Чулуун тоосгон хавтан",
  "block.minecraft.stone_brick_stairs": "Чулуун тоосгон шат",
  "block.minecraft.stone_brick_wall": "Чулуун тоосгон хана",
  "block.minecraft.stone_bricks": "Чулуун тоосго",
  "block.minecraft.stone_button": "Чулуун товч",
  "block.minecraft.stone_pressure_plate": "Чулуун даралтын хавтан",
  "block.minecraft.stone_slab": "Чулуун хавтан",
  "block.minecraft.stone_stairs": "Чулуун шат",
  "block.minecraft.stonecutter": "Чулуу зүсэгч",
  "block.minecraft.stripped_acacia_log": "Холтослосон хуайс модон дүнз",
  "block.minecraft.stripped_acacia_wood": "Холтослосон хуайс мод",
  "block.minecraft.stripped_bamboo_block": "Хуссан хулсан блок",
  "block.minecraft.stripped_birch_log": "Холтослосон хус модон дүнз",
  "block.minecraft.stripped_birch_wood": "Холтослосон хус мод",
  "block.minecraft.stripped_cherry_log": "Холтослосон интоорын модон дүнз",
  "block.minecraft.stripped_cherry_wood": "Холтослосон интоорын мод",
  "block.minecraft.stripped_crimson_hyphae": "Холтослосон нөжит мод",
  "block.minecraft.stripped_crimson_stem": "Холтослосон нөжит дүнз",
  "block.minecraft.stripped_dark_oak_log": "Холтослосон хар царс модон дүнз",
  "block.minecraft.stripped_dark_oak_wood": "Холтослосон хар царс мод",
  "block.minecraft.stripped_jungle_log": "Холтослосон ширэнгэн ойн модон дүнз",
  "block.minecraft.stripped_jungle_wood": "Холтослосон ширэнгэн ойн мод",
  "block.minecraft.stripped_mangrove_log": "Холтослосон мангро модон дүнз",
  "block.minecraft.stripped_mangrove_wood": "Холтослосон мангро мод",
  "block.minecraft.stripped_oak_log": "Холтослосон царс модон дүнз",
  "block.minecraft.stripped_oak_wood": "Холтослосон царс мод",
  "block.minecraft.stripped_pale_oak_log": "Холтослосон зэвхий царс модон дүнз",
  "block.minecraft.stripped_pale_oak_wood": "Холтослосон зэвхий царс мод",
  "block.minecraft.stripped_spruce_log": "Холтослосон гацуур модон дүнз",
  "block.minecraft.stripped_spruce_wood": "Холтослосон гацуур мод",
  "block.minecraft.stripped_warped_hyphae": "Холтослосон гажуудсан мод",
  "block.minecraft.stripped_warped_stem": "Холтослосон гажуудсан дүнз",
  "block.minecraft.structure_block": "Байгууламжийн блок",
  "block.minecraft.structure_void": "Байгууламжийн хоосон",
  "block.minecraft.sugar_cane": "Чихрийн нишингэ",
  "block.minecraft.sunflower": "Наранцэцэг",
  "block.minecraft.suspicious_gravel": "Сэжигтэй хайрга",
  "block.minecraft.suspicious_sand": "Сэжигтэй элс",
  "block.minecraft.sweet_berry_bush": "Чихэрлэг жимсгэнийн бут",
  "block.minecraft.tall_dry_grass": "Хатсан өндөр өвс",
  "block.minecraft.tall_grass": "Өндөр өвс",
  "block.minecraft.tall_seagrass": "Тэнгисийн өндөр өвс",
  "block.minecraft.target": "Бай",
  "block.minecraft.terracotta": "Хатуу шавар",
  "block.minecraft.test_block": "Шалгалтын блок",
  "block.minecraft.test_instance_block": "Туршилтын хувилбар блок",
  "block.minecraft.tinted_glass": "Харанхуй шил",
  "block.minecraft.tnt": "Тэслэгч",
  "block.minecraft.tnt.disabled": "TNT дэлбэрэлт идэвхгүй",
  "block.minecraft.torch": "Бамбар",
  "block.minecraft.torchflower": "Бамбар цэцэг",
  "block.minecraft.torchflower_crop": "Бамбар цэцгийн суулгац",
  "block.minecraft.trapped_chest": "Урхитай авдар",
  "block.minecraft.trial_spawner": "Сорилгын төрүүлэгч",
  "block.minecraft.tripwire": "Тээглүүр утас",
  "block.minecraft.tripwire_hook": "Тээглүүр утасны дэгээ",
  "block.minecraft.tube_coral": "Хоолой шүр",
  "block.minecraft.tube_coral_block": "Хоолой шүрэн блок",
  "block.minecraft.tube_coral_fan": "Хоолой шүрэн дэвүүр",
  "block.minecraft.tube_coral_wall_fan": "Хоолой шүрэн дэвүүр хананд",
  "block.minecraft.tuff": "Туф",
  "block.minecraft.tuff_brick_slab": "Туф тоосгон хавтан",
  "block.minecraft.tuff_brick_stairs": "Туф тоосгон шат",
  "block.minecraft.tuff_brick_wall": "Туф тоосгон хана",
  "block.minecraft.tuff_bricks": "Туф тоосго",
  "block.minecraft.tuff_slab": "Туф хавтан",
  "block.minecraft.tuff_stairs": "Туф шат",
  "block.minecraft.tuff_wall": "Туф хана",
  "block.minecraft.turtle_egg": "Яст мэлхийн өндөг",
  "block.minecraft.twisting_vines": "Мушгиа ургамал",
  "block.minecraft.twisting_vines_plant": "Мушгиа ургамал тарих",
  "block.minecraft.vault": "Эрдэнийн хайрцаг",
  "block.minecraft.verdant_froglight": "Ногоон мэлхийн гэрэл",
  "block.minecraft.vine": "Ороонго ургамал",
  "block.minecraft.void_air": "Хоосон агаар",
  "block.minecraft.wall_torch": "Ханын бамбар",
  "block.minecraft.warped_button": "Гажуудсан модон товч",
  "block.minecraft.warped_door": "Гажуудсан модон хаалга",
  "block.minecraft.warped_fence": "Гажуудсан модон хашаа",
  "block.minecraft.warped_fence_gate": "Гажуудсан модон хашааны хаалга",
  "block.minecraft.warped_fungus": "Гажуудсан мөөг",
  "block.minecraft.warped_hanging_sign": "Гажуудсан модон дүүжилдэг самбар",
  "block.minecraft.warped_hyphae": "Гажуудсан мод",
  "block.minecraft.warped_nylium": "Гажуудсан хөрс",
  "block.minecraft.warped_planks": "Гажуудсан модон банз",
  "block.minecraft.warped_pressure_plate": "Гажуудсан модон даралтын хавтан",
  "block.minecraft.warped_roots": "Гажуудсан ургамал",
  "block.minecraft.warped_shelf": "Гажуудсан модон тавиур",
  "block.minecraft.warped_sign": "Гажуудсан модон самбар",
  "block.minecraft.warped_slab": "Гажуудсан модон хавтан",
  "block.minecraft.warped_stairs": "Гажуудсан модон шат",
  "block.minecraft.warped_stem": "Гажуудсан дүнз",
  "block.minecraft.warped_trapdoor": "Гажуудсан модон сөхдөг хаалга",
  "block.minecraft.warped_wall_hanging_sign": "Гажуудсан модон хананаас дүүжилдэг самбар",
  "block.minecraft.warped_wall_sign": "Гажуудсан модон хананы самбар",
  "block.minecraft.warped_wart_block": "Гажуудсан үүн блок",
  "block.minecraft.water": "Ус",
  "block.minecraft.water_cauldron": "Устай тогоо",
  "block.minecraft.waxed_chiseled_copper": "Бүрэлттэй сийлсэн зэс",
  "block.minecraft.waxed_copper_bars": "Бүрэлттэй зэс тор",
  "block.minecraft.waxed_copper_block": "Бүрэлттэй зэс блок",
  "block.minecraft.waxed_copper_bulb": "Бүрэлттэй зэс гэрэл",
  "block.minecraft.waxed_copper_chain": "Бүрэлттэй зэс гинж",
  "block.minecraft.waxed_copper_chest": "Бүрэлттэй зэс авдар",
  "block.minecraft.waxed_copper_door": "Бүрэлттэй зэс хаалга",
  "block.minecraft.waxed_copper_golem_statue": "Бүрэлттэй зэс големын хөшөө",
  "block.minecraft.waxed_copper_grate": "Бүрэлттэй зэс сараалж",
  "block.minecraft.waxed_copper_lantern": "Бүрэлттэй зэс дэнлүү",
  "block.minecraft.waxed_copper_trapdoor": "Бүрэлттэй зэс сөхдөг хаалга",
  "block.minecraft.waxed_cut_copper": "Бүрэлттэй зүсмэл зэс",
  "block.minecraft.waxed_cut_copper_slab": "Бүрэлттэй зүсмэл зэс хавтан",
  "block.minecraft.waxed_cut_copper_stairs": "Бүрэлттэй зүсмэл зэс шат",
  "block.minecraft.waxed_exposed_chiseled_copper": "Бүрэлттэй өгөршсөн сийлсэн зэс",
  "block.minecraft.waxed_exposed_copper": "Бүрэлттэй өгөршсөн зэс",
  "block.minecraft.waxed_exposed_copper_bars": "Бүрэлттэй өгөршсөн зэс тор",
  "block.minecraft.waxed_exposed_copper_bulb": "Бүрэлттэй өгөршсөн зэс гэрэл",
  "block.minecraft.waxed_exposed_copper_chain": "Бүрэлттэй өгөршсөн зэс гинж",
  "block.minecraft.waxed_exposed_copper_chest": "Бүрэлттэй өгөршсөн зэс авдар",
  "block.minecraft.waxed_exposed_copper_door": "Бүрэлттэй өгөршсөн зэс хаалга",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Бүрэлттэй өгөршсөн зэс големын хөшөө",
  "block.minecraft.waxed_exposed_copper_grate": "Бүрэлттэй өгөршсөн зэс сараалж",
  "block.minecraft.waxed_exposed_copper_lantern": "Бүрэлттэй өгөршсөн зэс дэнлүү",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Бүрэлттэй өгөршсөн зэс сөхдөг хаалга",
  "block.minecraft.waxed_exposed_cut_copper": "Бүрэлттэй өгөршсөн зүсмэл зэс",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Бүрэлттэй өгөршсөн зүсмэл зэс хавтан",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Бүрэлттэй өгөршсөн зүсмэл зэс шат",
  "block.minecraft.waxed_exposed_lightning_rod": "Бүрэлттэй өгөршсөн аянга газардуулагч",
  "block.minecraft.waxed_lightning_rod": "Бүрэлттэй аянга газардуулагч",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Бүрэлттэй бүрэн исэлдсэн сийлсэн зэс",
  "block.minecraft.waxed_oxidized_copper": "Бүрэлттэй бүрэн исэлдсэн зэс",
  "block.minecraft.waxed_oxidized_copper_bars": "Бүрэлттэй бүрэн исэлдсэн зэс тор",
  "block.minecraft.waxed_oxidized_copper_bulb": "Бүрэлттэй бүрэн исэлдсэн зэс гэрэл",
  "block.minecraft.waxed_oxidized_copper_chain": "Бүрэлттэй бүрэн исэлдсэн зэс гинж",
  "block.minecraft.waxed_oxidized_copper_chest": "Бүрэлттэй бүрэн исэлдсэн зэс авдар",
  "block.minecraft.waxed_oxidized_copper_door": "Бүрэлттэй бүрэн исэлдсэн зэс хаалга",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Бүрэлттэй бүрэн исэлдсэн зэс големын хөшөө",
  "block.minecraft.waxed_oxidized_copper_grate": "Бүрэлттэй бүрэн исэлдсэн зэс сараалж",
  "block.minecraft.waxed_oxidized_copper_lantern": "Бүрэлттэй бүрэн исэлдсэн зэс дэнлүү",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Бүрэлттэй бүрэн исэлдсэн зэс сөхдөг хаалга",
  "block.minecraft.waxed_oxidized_cut_copper": "Бүрэлттэй бүрэн исэлдсэн зүсмэл зэс",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Бүрэлттэй бүрэн исэлдсэн зүсмэл зэс хавтан",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Бүрэлттэй бүрэн исэлдсэн зүсмэл зэс шат",
  "block.minecraft.waxed_oxidized_lightning_rod": "Бүрэлттэй бүрэн исэлдсэн аянга газардуулагч",
  "block.minecraft.waxed_weathered_chiseled_copper": "Бүрэлттэй исэлдсэн сийлсэн зэс",
  "block.minecraft.waxed_weathered_copper": "Бүрэлттэй исэлдсэн зэс",
  "block.minecraft.waxed_weathered_copper_bars": "Бүрэлттэй исэлдсэн зэс тор",
  "block.minecraft.waxed_weathered_copper_bulb": "Бүрэлттэй исэлдсэн зэс гэрэл",
  "block.minecraft.waxed_weathered_copper_chain": "Бүрэлттэй исэлдсэн зэс гинж",
  "block.minecraft.waxed_weathered_copper_chest": "Бүрэлттэй исэлдсэн зэс авдар",
  "block.minecraft.waxed_weathered_copper_door": "Бүрэлттэй исэлдсэн зэс хаалга",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Бүрэлттэй исэлдсэн зэс големын хөшөө",
  "block.minecraft.waxed_weathered_copper_grate": "Бүрэлттэй исэлдсэн зэс сараалж",
  "block.minecraft.waxed_weathered_copper_lantern": "Бүрэлттэй исэлдсэн зэс дэнлүү",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Бүрэлттэй исэлдсэн зэс сөхдөг хаалга",
  "block.minecraft.waxed_weathered_cut_copper": "Бүрэлттэй исэлдсэн зүсмэл зэс",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Бүрэлттэй исэлдсэн зүсмэл зэс хавтан",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Бүрэлттэй исэлдсэн зүсмэл зэс шат",
  "block.minecraft.waxed_weathered_lightning_rod": "Бүрэлттэй исэлдсэн аянга газардуулагч",
  "block.minecraft.weathered_chiseled_copper": "Исэдлсэн сийлсэн зэс",
  "block.minecraft.weathered_copper": "Исэлдсэн зэс",
  "block.minecraft.weathered_copper_bars": "Исэлдсэн зэс тор",
  "block.minecraft.weathered_copper_bulb": "Исэлдсэн зэс гэрэл",
  "block.minecraft.weathered_copper_chain": "Исэлдсэн зэс гинж",
  "block.minecraft.weathered_copper_chest": "Исэлдсэн зэс авдар",
  "block.minecraft.weathered_copper_door": "Исэлдсэн зэс хаалга",
  "block.minecraft.weathered_copper_golem_statue": "Исэлдсэн зэс големын хөшөө",
  "block.minecraft.weathered_copper_grate": "Исэлдсэн зэс сараалж",
  "block.minecraft.weathered_copper_lantern": "Исэлдсэн зэс дэнлүү",
  "block.minecraft.weathered_copper_trapdoor": "Исэлдсэн зэс сөхдөг хаалга",
  "block.minecraft.weathered_cut_copper": "Исэдлсэн зүсмэл зэс",
  "block.minecraft.weathered_cut_copper_slab": "Исэлдсэн зүсмэл зэс хавтан",
  "block.minecraft.weathered_cut_copper_stairs": "Исэлдсэн зүсмэл зэс шат",
  "block.minecraft.weathered_lightning_rod": "Исэлдсэн аянга газардуулагч",
  "block.minecraft.weeping_vines": "Уй гашууны ургамал",
  "block.minecraft.weeping_vines_plant": "Уй гашууны ургамал тарих",
  "block.minecraft.wet_sponge": "Нойтон хөвөн",
  "block.minecraft.wheat": "Улаан буудайн ургац",
  "block.minecraft.white_banner": "Цагаан туг",
  "block.minecraft.white_bed": "Цагаан ор",
  "block.minecraft.white_candle": "Цагаан лаа",
  "block.minecraft.white_candle_cake": "Цагаан лаатай бялуу",
  "block.minecraft.white_carpet": "Цагаан хивс",
  "block.minecraft.white_concrete": "Цагаан бетон",
  "block.minecraft.white_concrete_powder": "Цагаан нунтаг бетон",
  "block.minecraft.white_glazed_terracotta": "Цагаан хээтэй шавар",
  "block.minecraft.white_shulker_box": "Цагаан шалкер хайрцаг",
  "block.minecraft.white_stained_glass": "Цагаан будагтай шил",
  "block.minecraft.white_stained_glass_pane": "Цагаан будагтай шилэн хавтан",
  "block.minecraft.white_terracotta": "Цагаан хатуу шавар",
  "block.minecraft.white_tulip": "Цагаан алтанзул",
  "block.minecraft.white_wool": "Цагаан ноос",
  "block.minecraft.wildflowers": "Зэрлэг цэцэгс",
  "block.minecraft.wither_rose": "Витерийн сарнай",
  "block.minecraft.wither_skeleton_skull": "Витерийн гавлын яс",
  "block.minecraft.wither_skeleton_wall_skull": "Витерийн гавлын яс хананд",
  "block.minecraft.yellow_banner": "Шар туг",
  "block.minecraft.yellow_bed": "Шар ор",
  "block.minecraft.yellow_candle": "Шар лаа",
  "block.minecraft.yellow_candle_cake": "Шар лаатай бялуу",
  "block.minecraft.yellow_carpet": "Шар хивс",
  "block.minecraft.yellow_concrete": "Шар бетон",
  "block.minecraft.yellow_concrete_powder": "Шар нунтаг бетон",
  "block.minecraft.yellow_glazed_terracotta": "Шар хээтэй шавар",
  "block.minecraft.yellow_shulker_box": "Шар шалкер хайрцаг",
  "block.minecraft.yellow_stained_glass": "Шар будагтай шил",
  "block.minecraft.yellow_stained_glass_pane": "Шар будагтай шилэн хавтан",
  "block.minecraft.yellow_terracotta": "Шар хатуу шавар",
  "block.minecraft.yellow_wool": "Шар ноос",
  "block.minecraft.zombie_head": "Зомбины толгой",
  "block.minecraft.zombie_wall_head": "Зомбины толгой хананд",
  "item.minecraft.acacia_boat": "Хуайс модон завь",
  "item.minecraft.acacia_chest_boat": "Авдартай хуайс модон завь",
  "item.minecraft.allay_spawn_egg": "Дэмнэгч төрүүлэх өндөг",
  "item.minecraft.amethyst_shard": "Ягаан болор",
  "item.minecraft.angler_pottery_shard": "Загасчин хээтэй ваарын хэлтэрхий",
  "item.minecraft.angler_pottery_sherd": "Загасчин хээтэй ваарын хэлтэрхий",
  "item.minecraft.apple": "Алим",
  "item.minecraft.archer_pottery_shard": "Харваач хээтэй ваарын хэлтэрхий",
  "item.minecraft.archer_pottery_sherd": "Харваач хээтэй ваарын хэлтэрхий",
  "item.minecraft.armadillo_scute": "Армадиллогийн хуягны хэлтэрхий",
  "item.minecraft.armadillo_spawn_egg": "Армадилло төрүүлэх өндөг",
  "item.minecraft.armor_stand": "Хувцасны өлгүүр",
  "item.minecraft.arms_up_pottery_shard": "Гараа өргөсөн хээтэй ваарын хэлтэрхий",
  "item.minecraft.arms_up_pottery_sherd": "Гараа өргөсөн хээтэй ваарын хэлтэрхий",
  "item.minecraft.arrow": "Сум",
  "item.minecraft.axolotl_bucket": "Аксолотльтой хувин",
  "item.minecraft.axolotl_spawn_egg": "Аксолотль төрүүлэх өндөг",
  "item.minecraft.baked_potato": "Шарсан төмс",
  "item.minecraft.bamboo_chest_raft": "Авдартай хулсан сал",
  "item.minecraft.bamboo_raft": "Хулсан сал",
  "item.minecraft.bat_spawn_egg": "Сарьсан багваахай төрүүлэх өндөг",
  "item.minecraft.bee_spawn_egg": "Зөгий төрүүлэх өндөг",
  "item.minecraft.beef": "Түүхий үхрийн мах",
  "item.minecraft.beetroot": "Улаан манжин",
  "item.minecraft.beetroot_seeds": "Улаан манжингийн үр",
  "item.minecraft.beetroot_soup": "Улаан манжингийн шөл",
  "item.minecraft.birch_boat": "Хус модон завь",
  "item.minecraft.birch_chest_boat": "Авдартай хус модон завь",
  "item.minecraft.black_bundle": "Хар богц",
  "item.minecraft.black_dye": "Хар будаг",
  "item.minecraft.black_harness": "Хар тоног",
  "item.minecraft.blade_pottery_shard": "Илд хээтэй ваарын хэлтэрхий",
  "item.minecraft.blade_pottery_sherd": "Илд хээтэй ваарын хэлтэрхий",
  "item.minecraft.blaze_powder": "Түймэрдэгчийн нунтаг",
  "item.minecraft.blaze_rod": "Түймэрдэгчийн саваа",
  "item.minecraft.blaze_spawn_egg": "Түймэрдэгч төрүүлэх өндөг",
  "item.minecraft.blue_bundle": "Хөх богц",
  "item.minecraft.blue_dye": "Хөх будаг",
  "item.minecraft.blue_egg": "Хөх өндөг",
  "item.minecraft.blue_harness": "Хөх тоног",
  "item.minecraft.bogged_spawn_egg": "Намгийн араг яс төрүүлэх өндөг",
  "item.minecraft.bolt_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Шураг хуягийн эмжээр",
  "item.minecraft.bone": "Яс",
  "item.minecraft.bone_meal": "Нунтагласан яс",
  "item.minecraft.book": "Ном",
  "item.minecraft.bordure_indented_banner_pattern": "Арзгар хүрээ тугны хэв",
  "item.minecraft.bow": "Нум",
  "item.minecraft.bowl": "Аяга",
  "item.minecraft.bread": "Талх",
  "item.minecraft.breeze_rod": "Салхилагчийн саваа",
  "item.minecraft.breeze_spawn_egg": "Салхилагч төрүүлэх өндөг",
  "item.minecraft.brewer_pottery_shard": "Хандны хээтэй ваарын хэлтэрхий",
  "item.minecraft.brewer_pottery_sherd": "Хандны хээтэй ваарын хэлтэрхий",
  "item.minecraft.brewing_stand": "Ханд нэрэгч",
  "item.minecraft.brick": "Тоосго",
  "item.minecraft.brown_bundle": "Бор богц",
  "item.minecraft.brown_dye": "Бор будаг",
  "item.minecraft.brown_egg": "Бор өндөг",
  "item.minecraft.brown_harness": "Бор тоног",
  "item.minecraft.brush": "Багс",
  "item.minecraft.bucket": "Хувин",
  "item.minecraft.bundle": "Богц",
  "item.minecraft.bundle.empty": "Хоосон",
  "item.minecraft.bundle.empty.description": "Нийт нэг багц хүртэлх холимог эд зүйлсийг агуулж чадна",
  "item.minecraft.bundle.full": "Дүүрэн",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Гал хээтэй ваарын хэлтэрхий",
  "item.minecraft.burn_pottery_sherd": "Гал хээтэй ваарын хэлтэрхий",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Тэмээ төрүүлэх өндөг",
  "item.minecraft.carrot": "Лууван",
  "item.minecraft.carrot_on_a_stick": "Лууван зүүсэн уурга",
  "item.minecraft.cat_spawn_egg": "Муур төрүүлэх өндөг",
  "item.minecraft.cauldron": "Тогоо",
  "item.minecraft.cave_spider_spawn_egg": "Агуйн аалз төрүүлэх өндөг",
  "item.minecraft.chainmail_boots": "Гинжин гутал",
  "item.minecraft.chainmail_chestplate": "Гинжин цамц",
  "item.minecraft.chainmail_helmet": "Гинжин малгай",
  "item.minecraft.chainmail_leggings": "Гинжин өмд",
  "item.minecraft.charcoal": "Модны нүүрс",
  "item.minecraft.cherry_boat": "Интоорын модон завь",
  "item.minecraft.cherry_chest_boat": "Авдартай интоорын модон завь",
  "item.minecraft.chest_minecart": "Авдартай тэрэг",
  "item.minecraft.chicken": "Түүхий тахианы мах",
  "item.minecraft.chicken_spawn_egg": "Тахиа төрүүлэх өндөг",
  "item.minecraft.chorus_fruit": "Дахилтат жимс",
  "item.minecraft.clay_ball": "Шавар бөмбөг",
  "item.minecraft.clock": "Цаг",
  "item.minecraft.coal": "Нүүрс",
  "item.minecraft.coast_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Эрэг хуягийн эмжээр",
  "item.minecraft.cocoa_beans": "Какаоны шош",
  "item.minecraft.cod": "Түүхий сагамхай загас",
  "item.minecraft.cod_bucket": "Сагамхай загастай хувин",
  "item.minecraft.cod_spawn_egg": "Сагамхай загас төрүүлэх өндөр",
  "item.minecraft.command_block_minecart": "Тушаалын блоктой тэрэг",
  "item.minecraft.compass": "Луужин",
  "item.minecraft.cooked_beef": "Шарсан үхрийн мах",
  "item.minecraft.cooked_chicken": "Шарсан тахианы мах",
  "item.minecraft.cooked_cod": "Шарсан сагамхай загас",
  "item.minecraft.cooked_mutton": "Шарсан хонины мах",
  "item.minecraft.cooked_porkchop": "Шарсан гахайн мах",
  "item.minecraft.cooked_rabbit": "Шарсан туулайн мах",
  "item.minecraft.cooked_salmon": "Шарсан яргай загас",
  "item.minecraft.cookie": "Жигнэмэг",
  "item.minecraft.copper_axe": "Зэс сүх",
  "item.minecraft.copper_boots": "Зэс гутал",
  "item.minecraft.copper_chestplate": "Зэс цамц",
  "item.minecraft.copper_golem_spawn_egg": "Зэс голем төрүүлэх өндөг",
  "item.minecraft.copper_helmet": "Зэс малгай",
  "item.minecraft.copper_hoe": "Зэс зээтүү",
  "item.minecraft.copper_horse_armor": "Морины зэс хуяг",
  "item.minecraft.copper_ingot": "Зэс",
  "item.minecraft.copper_leggings": "Зэс өмд",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Зэсийн хэлтэрхий",
  "item.minecraft.copper_pickaxe": "Зэс ёотуу",
  "item.minecraft.copper_shovel": "Зэс хүрз",
  "item.minecraft.copper_spear": "Зэс жад",
  "item.minecraft.copper_sword": "Зэс сэлэм",
  "item.minecraft.cow_spawn_egg": "Үхэр төрүүлэх өндөг",
  "item.minecraft.creaking_spawn_egg": "Хяхнагч төрүүлэх өндөг",
  "item.minecraft.creeper_banner_pattern": "Тугны хэв",
  "item.minecraft.creeper_banner_pattern.desc": "Криперийн нүүр",
  "item.minecraft.creeper_banner_pattern.new": "Крипер тугны хэв",
  "item.minecraft.creeper_spawn_egg": "Крипер төрүүлэх өндөг",
  "item.minecraft.crossbow": "Хулгавч нум",
  "item.minecraft.crossbow.projectile": "Сум:",
  "item.minecraft.crossbow.projectile.multiple": "Сум: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Сум: %s",
  "item.minecraft.cyan_bundle": "Номин цэнхэр богц",
  "item.minecraft.cyan_dye": "Номин цэнхэр будаг",
  "item.minecraft.cyan_harness": "Цэнхэр тоног",
  "item.minecraft.danger_pottery_shard": "Аюул хээтэй ваарын хэлтэрхий",
  "item.minecraft.danger_pottery_sherd": "Аюул хээтэй ваарын хэлтэрхий",
  "item.minecraft.dark_oak_boat": "Хар царс модон завь",
  "item.minecraft.dark_oak_chest_boat": "Авдартай хар царс модон завь",
  "item.minecraft.debug_stick": "Шалгах саваа",
  "item.minecraft.debug_stick.empty": "%s ямар ч шинж чанаргүй",
  "item.minecraft.debug_stick.select": "\"%s\" (%s)-г сонгосон",
  "item.minecraft.debug_stick.update": "\"%s\"-г %s болгосон",
  "item.minecraft.diamond": "Алмаас эрдэнэ",
  "item.minecraft.diamond_axe": "Алмаасан сүх",
  "item.minecraft.diamond_boots": "Алмаасан гутал",
  "item.minecraft.diamond_chestplate": "Алмаасан цамц",
  "item.minecraft.diamond_helmet": "Алмаасан малгай",
  "item.minecraft.diamond_hoe": "Алмаасан зээтүү",
  "item.minecraft.diamond_horse_armor": "Морины алмаасан хуяг",
  "item.minecraft.diamond_leggings": "Алмаасан өмд",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Алмаасан ёотуу",
  "item.minecraft.diamond_shovel": "Алмаасан хүрз",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Алмаасан сэлэм",
  "item.minecraft.disc_fragment_5": "Пянзны хэлтэрхий",
  "item.minecraft.disc_fragment_5.desc": "Пянз - 5",
  "item.minecraft.dolphin_spawn_egg": "Далайн гахай төрүүлэх өндөг",
  "item.minecraft.donkey_spawn_egg": "Илжиг төрүүлэх өндөг",
  "item.minecraft.dragon_breath": "Лууны амьсгал",
  "item.minecraft.dried_kelp": "Хатаасан замаг",
  "item.minecraft.drowned_spawn_egg": "Тэнгисийн зомби төрүүлэх өндөг",
  "item.minecraft.dune_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Манхан хуягийн эмжээр",
  "item.minecraft.echo_shard": "Цуурайн хэлтэрхий",
  "item.minecraft.egg": "Өндөг",
  "item.minecraft.elder_guardian_spawn_egg": "Ахмад хамгаалагч төрүүлэх өндөг",
  "item.minecraft.elytra": "Далавч",
  "item.minecraft.emerald": "Маргад эрдэнэ",
  "item.minecraft.enchanted_book": "Шидэт ном",
  "item.minecraft.enchanted_golden_apple": "Шидэт алтан алим",
  "item.minecraft.end_crystal": "Ээндийн талст",
  "item.minecraft.ender_dragon_spawn_egg": "Ээндийн луу төрүүлэх өндөг",
  "item.minecraft.ender_eye": "Ээндэрийн нүд",
  "item.minecraft.ender_pearl": "Ээндэрийн сувд",
  "item.minecraft.enderman_spawn_egg": "Ээндийн хүн төрүүлэх өндөг",
  "item.minecraft.endermite_spawn_egg": "Ээндийн хачиг төрүүлэх",
  "item.minecraft.evoker_spawn_egg": "Сүнс дуудагч төрүүлэх өндөг",
  "item.minecraft.experience_bottle": "Ид шидтэй лонх",
  "item.minecraft.explorer_pottery_shard": "Аялагч хээтэй ваарын хэлтэрхий",
  "item.minecraft.explorer_pottery_sherd": "Аялагч хээтэй ваарын хэлтэрхий",
  "item.minecraft.eye_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Нүд хуягийн эмжээр",
  "item.minecraft.feather": "Өд",
  "item.minecraft.fermented_spider_eye": "Исгэсэн аалзны нүд",
  "item.minecraft.field_masoned_banner_pattern": "Тоосгон тугны хэв",
  "item.minecraft.filled_map": "Газрын зураг",
  "item.minecraft.fire_charge": "Галт бөмбөг",
  "item.minecraft.firework_rocket": "Галт пуужин",
  "item.minecraft.firework_rocket.flight": "Нисэх хугацаа:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Галт од",
  "item.minecraft.firework_star.black": "Хар",
  "item.minecraft.firework_star.blue": "Хөх",
  "item.minecraft.firework_star.brown": "Бор",
  "item.minecraft.firework_star.custom_color": "Тусгай",
  "item.minecraft.firework_star.cyan": "Номин цэнхэр",
  "item.minecraft.firework_star.fade_to": "Уусах",
  "item.minecraft.firework_star.flicker": "Одод",
  "item.minecraft.firework_star.gray": "Саарал",
  "item.minecraft.firework_star.green": "Ногоон",
  "item.minecraft.firework_star.light_blue": "Цэнхэр",
  "item.minecraft.firework_star.light_gray": "Цайвар саарал",
  "item.minecraft.firework_star.lime": "Цайвар ногоон",
  "item.minecraft.firework_star.magenta": "Нил ягаан",
  "item.minecraft.firework_star.orange": "Улбар шар",
  "item.minecraft.firework_star.pink": "Цайвар ягаан",
  "item.minecraft.firework_star.purple": "Нил ягаан",
  "item.minecraft.firework_star.red": "Улаан",
  "item.minecraft.firework_star.shape": "Тодорхойгүй дүрс",
  "item.minecraft.firework_star.shape.burst": "Тэсрэлт",
  "item.minecraft.firework_star.shape.creeper": "Крипер хэлбэртэй",
  "item.minecraft.firework_star.shape.large_ball": "Том бөмбөг",
  "item.minecraft.firework_star.shape.small_ball": "Жижиг бөмбөг",
  "item.minecraft.firework_star.shape.star": "Од хэлбэртэй",
  "item.minecraft.firework_star.trail": "Цацраг",
  "item.minecraft.firework_star.white": "Цагаан",
  "item.minecraft.firework_star.yellow": "Шар",
  "item.minecraft.fishing_rod": "Загасны уурга",
  "item.minecraft.flint": "Цахиур",
  "item.minecraft.flint_and_steel": "Цахиур төмөр",
  "item.minecraft.flow_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Урсгал хуягийн эмжээр",
  "item.minecraft.flow_banner_pattern": "Тугны хэв",
  "item.minecraft.flow_banner_pattern.desc": "Урсгал",
  "item.minecraft.flow_banner_pattern.new": "Урсгал тугны хэв",
  "item.minecraft.flow_pottery_sherd": "Урсгал хээтэй ваарын хэлтэрхий",
  "item.minecraft.flower_banner_pattern": "Тугийн хэв",
  "item.minecraft.flower_banner_pattern.desc": "Цэцэг",
  "item.minecraft.flower_banner_pattern.new": "Цэцэг тугны хэв",
  "item.minecraft.flower_pot": "Цэцгийн сав",
  "item.minecraft.fox_spawn_egg": "Үнэг төрүүлэх өндөг",
  "item.minecraft.friend_pottery_shard": "Нөхөр хээтэй ваарын хэлтэрхий",
  "item.minecraft.friend_pottery_sherd": "Нөхөр хээтэй ваарын хэлтэрхий",
  "item.minecraft.frog_spawn_egg": "Мэлхий төрүүлэх өндөг",
  "item.minecraft.furnace_minecart": "Зуухтай тэрэг",
  "item.minecraft.ghast_spawn_egg": "Гаст төрүүлэх өндөг",
  "item.minecraft.ghast_tear": "Гастын нулимс",
  "item.minecraft.glass_bottle": "Лонх",
  "item.minecraft.glistering_melon_slice": "Гялтагнадаг зүсэм тарвас",
  "item.minecraft.globe_banner_pattern": "Тугийн хэв",
  "item.minecraft.globe_banner_pattern.desc": "Бөмбөрцөг",
  "item.minecraft.globe_banner_pattern.new": "Бөмбөрцөг тугны хэв",
  "item.minecraft.glow_berries": "Гэрэлт жимсгэнэ",
  "item.minecraft.glow_ink_sac": "Гэрэлт бэх",
  "item.minecraft.glow_item_frame": "Гэрэлт эд зүйлийн хүрээ",
  "item.minecraft.glow_squid_spawn_egg": "Гэрэлт наймалж төрүүлэх өндөг",
  "item.minecraft.glowstone_dust": "Гэрэлт тоос",
  "item.minecraft.goat_horn": "Ямааны эвэр",
  "item.minecraft.goat_spawn_egg": "Ямаа төрүүлэх өндөг",
  "item.minecraft.gold_ingot": "Алт",
  "item.minecraft.gold_nugget": "Шижир алт",
  "item.minecraft.golden_apple": "Алтан алим",
  "item.minecraft.golden_axe": "Алтан сүх",
  "item.minecraft.golden_boots": "Алтан гутал",
  "item.minecraft.golden_carrot": "Алтан лууван",
  "item.minecraft.golden_chestplate": "Алтан цамц",
  "item.minecraft.golden_helmet": "Алтан малгай",
  "item.minecraft.golden_hoe": "Алтан зээтүү",
  "item.minecraft.golden_horse_armor": "Морины алтан хуяг",
  "item.minecraft.golden_leggings": "Алтан өмд",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Алтан ёотуу",
  "item.minecraft.golden_shovel": "Алтан хүрз",
  "item.minecraft.golden_spear": "Алтан жад",
  "item.minecraft.golden_sword": "Алтан сэлэм",
  "item.minecraft.gray_bundle": "Саарал богц",
  "item.minecraft.gray_dye": "Саарал будаг",
  "item.minecraft.gray_harness": "Саарал тоног",
  "item.minecraft.green_bundle": "Ногоон богц",
  "item.minecraft.green_dye": "Ногоон будаг",
  "item.minecraft.green_harness": "Ногоон тоног",
  "item.minecraft.guardian_spawn_egg": "Хамгаалагч төрүүлэх өндөг",
  "item.minecraft.gunpowder": "Дарь",
  "item.minecraft.guster_banner_pattern": "Тугны хэв",
  "item.minecraft.guster_banner_pattern.desc": "Шуурга",
  "item.minecraft.guster_banner_pattern.new": "Шуурга тугны хэв",
  "item.minecraft.guster_pottery_sherd": "Шуурга хээтэй ваарын хэлтэрхий",
  "item.minecraft.happy_ghast_spawn_egg": "Жаргалтай гаст төрүүлэх өндөг",
  "item.minecraft.harness": "Тоног",
  "item.minecraft.heart_of_the_sea": "Тэнгисийн зүрх",
  "item.minecraft.heart_pottery_shard": "Зүрхэн хээтэй ваарын хэлтэрхий",
  "item.minecraft.heart_pottery_sherd": "Зүрхэн хээтэй ваарын хэлтэрхий",
  "item.minecraft.heartbreak_pottery_shard": "Хуваагдсан зүрхэн хээтэй ваарын хэлтэрхий",
  "item.minecraft.heartbreak_pottery_sherd": "Хуваагдсан зүрхэн хээтэй ваарын хэлтэрхий",
  "item.minecraft.hoglin_spawn_egg": "Хоглин төрүүлэх өндөг",
  "item.minecraft.honey_bottle": "Шилтэй зөгийн бал",
  "item.minecraft.honeycomb": "Зөгийн сархинаг",
  "item.minecraft.hopper_minecart": "Гулгуулагчтай тэрэг",
  "item.minecraft.horse_spawn_egg": "Морь төрүүлэх өндөг",
  "item.minecraft.host_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.host_armor_trim_smithing_template.new": "Эзэн хуягийн эмжээр",
  "item.minecraft.howl_pottery_shard": "Чонын хээтэй ваарын хэлтэрхий",
  "item.minecraft.howl_pottery_sherd": "Чонын хээтэй ваарын хэлтэрхий",
  "item.minecraft.husk_spawn_egg": "Хатсан зомби төрүүлэх өндөг",
  "item.minecraft.ink_sac": "Бэх",
  "item.minecraft.iron_axe": "Төмөр сүх",
  "item.minecraft.iron_boots": "Төмөр гутал",
  "item.minecraft.iron_chestplate": "Төмөр цамц",
  "item.minecraft.iron_golem_spawn_egg": "Төмөр хүн төрүүлэх өндөг",
  "item.minecraft.iron_helmet": "Төмөр малгай",
  "item.minecraft.iron_hoe": "Төмөр зээтүү",
  "item.minecraft.iron_horse_armor": "Морины төмөр хуяг",
  "item.minecraft.iron_ingot": "Төмөр",
  "item.minecraft.iron_leggings": "Төмөр өмд",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Төмрийн хэлтэрхий",
  "item.minecraft.iron_pickaxe": "Төмөр ёотуу",
  "item.minecraft.iron_shovel": "Төмөр хүрз",
  "item.minecraft.iron_spear": "Төмөр жад",
  "item.minecraft.iron_sword": "Төмөр сэлэм",
  "item.minecraft.item_frame": "Эд зүйлийн хүрээ",
  "item.minecraft.jungle_boat": "Ширэнгэн ойн модон завь",
  "item.minecraft.jungle_chest_boat": "Авдартай ширэнгэн ойн модон завь",
  "item.minecraft.knowledge_book": "Мэдлэгийн ном",
  "item.minecraft.lapis_lazuli": "Номин чулуу",
  "item.minecraft.lava_bucket": "Хайлмагтай хувин",
  "item.minecraft.lead": "Уяа",
  "item.minecraft.leather": "Арьс",
  "item.minecraft.leather_boots": "Арьсан гутал",
  "item.minecraft.leather_chestplate": "Арьсан цамц",
  "item.minecraft.leather_helmet": "Арьсан малгай",
  "item.minecraft.leather_horse_armor": "Морины арьсан хуяг",
  "item.minecraft.leather_leggings": "Арьсан өмд",
  "item.minecraft.light_blue_bundle": "Цэнхэр богц",
  "item.minecraft.light_blue_dye": "Цэнхэр будаг",
  "item.minecraft.light_blue_harness": "Цайвар цэнхэр тоног",
  "item.minecraft.light_gray_bundle": "Цайвар саарал богц",
  "item.minecraft.light_gray_dye": "Цайвар саарал будаг",
  "item.minecraft.light_gray_harness": "Цайвар саарал тоног",
  "item.minecraft.lime_bundle": "Цайвар ногоон богц",
  "item.minecraft.lime_dye": "Цайвар ногоон будаг",
  "item.minecraft.lime_harness": "Цайвар ногоон тоног",
  "item.minecraft.lingering_potion": "Ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.awkward": "Ууршимтгай эвгүй ханд",
  "item.minecraft.lingering_potion.effect.empty": "Ууршимтгай гаргах боломжгүй ханд",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Галд тэсвэртэй болгох ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.harming": "Хохирол учруулах ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.healing": "Амь нэмэх ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.infested": "Бөөстүүлэх уурших ханд",
  "item.minecraft.lingering_potion.effect.invisibility": "Үл үзэгдүүлэх ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.leaping": "Өндөр үсэргэх ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.levitation": "Хөөргөх ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.luck": "Азын ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.mundane": "Ууршимтгай хар ханд",
  "item.minecraft.lingering_potion.effect.night_vision": "Харанхуйд харуулах ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.oozing": "Салс дуслуулах уурших ханд",
  "item.minecraft.lingering_potion.effect.poison": "Хортой ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.regeneration": "Амь нөхөх ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.slow_falling": "Өд шиг хөнгөн болгох ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.slowness": "Удаашруулах ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.strength": "Хүч оруулах ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.swiftness": "Хурдлуулах ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.thick": "Ууршимтгай өтгөн ханд",
  "item.minecraft.lingering_potion.effect.turtle_master": "Яст мэлхий мастерийн ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.water": "Ууршимтгай устай лонх",
  "item.minecraft.lingering_potion.effect.water_breathing": "Усанд амьсгалуулах ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.weakness": "Хүчгүй болгох ууршимтгай ханд",
  "item.minecraft.lingering_potion.effect.weaving": "Нэхмэлийн уурших ханд",
  "item.minecraft.lingering_potion.effect.wind_charged": "Салхиар цэнэглэх уурших ханд",
  "item.minecraft.llama_spawn_egg": "Тэмээн гөрөөс төрүүлэх өндөг",
  "item.minecraft.lodestone_compass": "Чиглүүлсэн луужин",
  "item.minecraft.mace": "Бялуу шийдэм",
  "item.minecraft.magenta_bundle": "Ягаан богц",
  "item.minecraft.magenta_dye": "Ягаан будаг",
  "item.minecraft.magenta_harness": "Ягаан тоног",
  "item.minecraft.magma_cream": "Хайлмаган тос",
  "item.minecraft.magma_cube_spawn_egg": "Хайлмаган куб төрүүлэх өндөг",
  "item.minecraft.mangrove_boat": "Мангро модон завь",
  "item.minecraft.mangrove_chest_boat": "Авдартай мангро модон завь",
  "item.minecraft.map": "Хоосон газрын зураг",
  "item.minecraft.melon_seeds": "Тарвасны үр",
  "item.minecraft.melon_slice": "Зүсэм тарвас",
  "item.minecraft.milk_bucket": "Сүүтэй хувин",
  "item.minecraft.minecart": "Уурхайн тэрэг",
  "item.minecraft.miner_pottery_shard": "Уурхайчин хээтэй ваарын хэлтэрхий",
  "item.minecraft.miner_pottery_sherd": "Уурхайчин хээтэй ваарын хэлтэрхий",
  "item.minecraft.mojang_banner_pattern": "Тугийн хэв",
  "item.minecraft.mojang_banner_pattern.desc": "Зүйл",
  "item.minecraft.mojang_banner_pattern.new": "Зүйл тугны хэв",
  "item.minecraft.mooshroom_spawn_egg": "Мүүшрүүм төрүүлэх өндөг",
  "item.minecraft.mourner_pottery_shard": "Гаслагч хээтэй ваарын хэлтэрхий",
  "item.minecraft.mourner_pottery_sherd": "Гаслагч хээтэй ваарын хэлтэрхий",
  "item.minecraft.mule_spawn_egg": "Луус төрүүлэх өндөг",
  "item.minecraft.mushroom_stew": "Мөөгтэй шөл",
  "item.minecraft.music_disc_11": "Пянз",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Пянз",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Пянз",
  "item.minecraft.music_disc_5.desc": "Самуель Оберг - 5",
  "item.minecraft.music_disc_blocks": "Пянз",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Пянз",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Пянз",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Пянз",
  "item.minecraft.music_disc_creator.desc": "Лена Рэйн - Creator",
  "item.minecraft.music_disc_creator_music_box": "Пянз",
  "item.minecraft.music_disc_creator_music_box.desc": "Лена Рэйн - Creator (Эгшигт хайрцаг)",
  "item.minecraft.music_disc_far": "Пянз",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Пянз",
  "item.minecraft.music_disc_lava_chicken.desc": "Хайпер Поушнс - Lava Chicken",
  "item.minecraft.music_disc_mall": "Пянз",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Пянз",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Пянз",
  "item.minecraft.music_disc_otherside.desc": "Лена Рэйн - otherside",
  "item.minecraft.music_disc_pigstep": "Пянз",
  "item.minecraft.music_disc_pigstep.desc": "Лена Рэйн - Pigstep",
  "item.minecraft.music_disc_precipice": "Пянз",
  "item.minecraft.music_disc_precipice.desc": "Аарон Шероф - Precipice",
  "item.minecraft.music_disc_relic": "Пянз",
  "item.minecraft.music_disc_relic.desc": "Аарон Шероф - Relic",
  "item.minecraft.music_disc_stal": "Пянз",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Пянз",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Пянз",
  "item.minecraft.music_disc_tears.desc": "Амос Родди - Tears",
  "item.minecraft.music_disc_wait": "Пянз",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Пянз",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Түүхий хонины мах",
  "item.minecraft.name_tag": "Нэрийн шошго",
  "item.minecraft.nautilus_shell": "Дунгийн яс",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Тамын тоосго",
  "item.minecraft.nether_star": "Тамын од",
  "item.minecraft.nether_wart": "Тамын үү",
  "item.minecraft.netherite_axe": "Недерит сүх",
  "item.minecraft.netherite_boots": "Недерит гутал",
  "item.minecraft.netherite_chestplate": "Недерит цамц",
  "item.minecraft.netherite_helmet": "Недерит малгай",
  "item.minecraft.netherite_hoe": "Недерит зээтүү",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Недерит",
  "item.minecraft.netherite_leggings": "Недерит өмд",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Недерит ёотуу",
  "item.minecraft.netherite_scrap": "Недеритийн хэлтэрхий",
  "item.minecraft.netherite_shovel": "Недерит хүрз",
  "item.minecraft.netherite_spear": "Недерит жад",
  "item.minecraft.netherite_sword": "Недерит сэлэм",
  "item.minecraft.netherite_upgrade_smithing_template": "Дархны хэв",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Недерит сайжруулалт",
  "item.minecraft.oak_boat": "Царс модон завь",
  "item.minecraft.oak_chest_boat": "Авдартай царс модон завь",
  "item.minecraft.ocelot_spawn_egg": "Ирвэс төрүүлэх өндөг",
  "item.minecraft.ominous_bottle": "Ёрын лонх",
  "item.minecraft.ominous_trial_key": "Ёрын сорилгын түлхүүр",
  "item.minecraft.orange_bundle": "Улбар шар богц",
  "item.minecraft.orange_dye": "Улбар шар будаг",
  "item.minecraft.orange_harness": "Улбар шар тоног",
  "item.minecraft.painting": "Уран зураг",
  "item.minecraft.pale_oak_boat": "Зэвхий царс модон завь",
  "item.minecraft.pale_oak_chest_boat": "Авдартай зэвхий царс модон завь",
  "item.minecraft.panda_spawn_egg": "Хулсны баавгай төрүүлэх өндөг",
  "item.minecraft.paper": "Цаас",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Тоть төрүүлэх өндөг",
  "item.minecraft.phantom_membrane": "Фантомын хальс",
  "item.minecraft.phantom_spawn_egg": "Фантом төрүүлэх өндөг",
  "item.minecraft.pig_spawn_egg": "Гахай төрүүлэх өндөг",
  "item.minecraft.piglin_banner_pattern": "Тугийн хэв",
  "item.minecraft.piglin_banner_pattern.desc": "Хоншоор",
  "item.minecraft.piglin_banner_pattern.new": "Хамар тугны хэв",
  "item.minecraft.piglin_brute_spawn_egg": "Харгис пиглин төрүүлэх өндөг",
  "item.minecraft.piglin_spawn_egg": "Пиглин төрүүлэх өндөг",
  "item.minecraft.pillager_spawn_egg": "Дээрэмчин төрүүлэх өндөг",
  "item.minecraft.pink_bundle": "Цайвар ягаан богц",
  "item.minecraft.pink_dye": "Цайвар ягаан будаг",
  "item.minecraft.pink_harness": "Цайвар ягаан тоног",
  "item.minecraft.pitcher_plant": "Саррацени",
  "item.minecraft.pitcher_pod": "Сарраценийн буурцаг",
  "item.minecraft.plenty_pottery_shard": "Элбэг дэлбэгийн хээтэй ваарын хэлтэрхий",
  "item.minecraft.plenty_pottery_sherd": "Элбэг дэлбэгийн хээтэй ваарын хэлтэрхий",
  "item.minecraft.poisonous_potato": "Хортой төмс",
  "item.minecraft.polar_bear_spawn_egg": "Цагаан баавгай төрүүлэх өндөг",
  "item.minecraft.popped_chorus_fruit": "Хөөсөн дахилтат жимс",
  "item.minecraft.porkchop": "Түүхий гахайн мах",
  "item.minecraft.potato": "Төмс",
  "item.minecraft.potion": "Ханд",
  "item.minecraft.potion.effect.awkward": "Эвгүй ханд",
  "item.minecraft.potion.effect.empty": "Гаргах боломжгүй ханд",
  "item.minecraft.potion.effect.fire_resistance": "Галд тэсвэртэй болгох ханд",
  "item.minecraft.potion.effect.harming": "Хохирол учруулах ханд",
  "item.minecraft.potion.effect.healing": "Амь нэмэх ханд",
  "item.minecraft.potion.effect.infested": "Бөөстүүлэх ханд",
  "item.minecraft.potion.effect.invisibility": "Үл үзэгдүүлэх ханд",
  "item.minecraft.potion.effect.leaping": "Өндөр үсэргэх ханд",
  "item.minecraft.potion.effect.levitation": "Хөөргөх ханд",
  "item.minecraft.potion.effect.luck": "Азын ханд",
  "item.minecraft.potion.effect.mundane": "Хар ханд",
  "item.minecraft.potion.effect.night_vision": "Харанхуйд харуулах ханд",
  "item.minecraft.potion.effect.oozing": "Салс дуслуулах ханд",
  "item.minecraft.potion.effect.poison": "Хор",
  "item.minecraft.potion.effect.regeneration": "Амь нөхөх ханд",
  "item.minecraft.potion.effect.slow_falling": "Өд шиг хөнгөн болгох ханд",
  "item.minecraft.potion.effect.slowness": "Удаашруулах ханд",
  "item.minecraft.potion.effect.strength": "Хүч оруулах ханд",
  "item.minecraft.potion.effect.swiftness": "Хурдлуулах ханд",
  "item.minecraft.potion.effect.thick": "Өтгөн ханд",
  "item.minecraft.potion.effect.turtle_master": "Яст мэлхий мастерийн ханд",
  "item.minecraft.potion.effect.water": "Устай лонх",
  "item.minecraft.potion.effect.water_breathing": "Усанд амьсгалуулах ханд",
  "item.minecraft.potion.effect.weakness": "Хүчгүй болгох ханд",
  "item.minecraft.potion.effect.weaving": "Нэхмэлийн ханд",
  "item.minecraft.potion.effect.wind_charged": "Салхиар цэнэглэх ханд",
  "item.minecraft.pottery_shard_archer": "Харваач хээтэй ваарын хэлтэрхий",
  "item.minecraft.pottery_shard_arms_up": "Гараа өргөсөн хээтэй ваарын хэлтэрхий",
  "item.minecraft.pottery_shard_prize": "Шагнал хээтэй ваарын хэлтэрхий",
  "item.minecraft.pottery_shard_skull": "Гавлын ясан хээтэй ваарын хэлтэрхий",
  "item.minecraft.powder_snow_bucket": "Сэвсгэр цастай хувин",
  "item.minecraft.prismarine_crystals": "Присмарины талст",
  "item.minecraft.prismarine_shard": "Присмарины хэлтэрхий",
  "item.minecraft.prize_pottery_shard": "Алмаасан хээтэй ваарын хэлтэрхий",
  "item.minecraft.prize_pottery_sherd": "Алмаасан хээтэй ваарын хэлтэрхий",
  "item.minecraft.pufferfish": "Үлээгч загас",
  "item.minecraft.pufferfish_bucket": "Үлээгч загастай хувин",
  "item.minecraft.pufferfish_spawn_egg": "Үлээгч загас төрүүлэх",
  "item.minecraft.pumpkin_pie": "Хулууны бялуу",
  "item.minecraft.pumpkin_seeds": "Хулууны үр",
  "item.minecraft.purple_bundle": "Нил ягаан богц",
  "item.minecraft.purple_dye": "Нил ягаан будаг",
  "item.minecraft.purple_harness": "Нил ягаан тоног",
  "item.minecraft.quartz": "Кварц",
  "item.minecraft.rabbit": "Түүхийн туулайн мах",
  "item.minecraft.rabbit_foot": "Туулайн хөл",
  "item.minecraft.rabbit_hide": "Туулайн арьс",
  "item.minecraft.rabbit_spawn_egg": "Туулай төрүүлэх өндөг",
  "item.minecraft.rabbit_stew": "Туулайн шөл",
  "item.minecraft.raiser_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Мандагч хуягийн эмжээр",
  "item.minecraft.ravager_spawn_egg": "Сүйтгэгч төрүүлэх өндөг",
  "item.minecraft.raw_copper": "Боловсруулаагүй зэс",
  "item.minecraft.raw_gold": "Боловсруулаагүй алт",
  "item.minecraft.raw_iron": "Боловсруулаагүй төмөр",
  "item.minecraft.recovery_compass": "Авралын луужин",
  "item.minecraft.red_bundle": "Улаан богц",
  "item.minecraft.red_dye": "Улаан будаг",
  "item.minecraft.red_harness": "Улаан тоног",
  "item.minecraft.redstone": "Редстоуны тоос",
  "item.minecraft.resin_brick": "Давирхайн тоосго",
  "item.minecraft.resin_clump": "Бөөгнөсөн давирхай",
  "item.minecraft.rib_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Хавирга хуягийн эмжээр",
  "item.minecraft.rotten_flesh": "Муудсан мах",
  "item.minecraft.saddle": "Эмээл",
  "item.minecraft.salmon": "Түүхий яргай загас",
  "item.minecraft.salmon_bucket": "Яргай загастай хувин",
  "item.minecraft.salmon_spawn_egg": "Яргай загас төрүүлэх өндөг",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Хуягны хэлтэрхий",
  "item.minecraft.sentry_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Харуул хуягийн эмжээр",
  "item.minecraft.shaper_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Хэлбэржүүлэгч хуягийн эмжээр",
  "item.minecraft.sheaf_pottery_shard": "Боодол хээтэй ваарын хэлтэрхий",
  "item.minecraft.sheaf_pottery_sherd": "Боодол хээтэй ваарын хэлтэрхий",
  "item.minecraft.shears": "Хайч",
  "item.minecraft.sheep_spawn_egg": "Хонь төрүүлэх өндөг",
  "item.minecraft.shelter_pottery_shard": "Оромж хээтэй ваарын хэлтэрхий",
  "item.minecraft.shelter_pottery_sherd": "Оромж хээтэй ваарын хэлтэрхий",
  "item.minecraft.shield": "Бамбай",
  "item.minecraft.shield.black": "Хар бамбай",
  "item.minecraft.shield.blue": "Хөх бамбай",
  "item.minecraft.shield.brown": "Бор бамбай",
  "item.minecraft.shield.cyan": "Номин цэнхэр бамбай",
  "item.minecraft.shield.gray": "Саарал бамбай",
  "item.minecraft.shield.green": "Ногоон бамбай",
  "item.minecraft.shield.light_blue": "Цэнхэр бамбай",
  "item.minecraft.shield.light_gray": "Цайвар саарал бамбай",
  "item.minecraft.shield.lime": "Цайвар ногоон бамбай",
  "item.minecraft.shield.magenta": "Ягаан бамбай",
  "item.minecraft.shield.orange": "Улбар шар бамбай",
  "item.minecraft.shield.pink": "Цайвар ягаан бамбай",
  "item.minecraft.shield.purple": "Нил ягаан бамбай",
  "item.minecraft.shield.red": "Улаан бамбай",
  "item.minecraft.shield.white": "Цагаан бамбай",
  "item.minecraft.shield.yellow": "Шар бамбай",
  "item.minecraft.shulker_shell": "Шалкерийн хуяг",
  "item.minecraft.shulker_spawn_egg": "Шалкер төрүүлэх өндөг",
  "item.minecraft.sign": "Самбар",
  "item.minecraft.silence_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Чимээгүй хуягийн эмжээр",
  "item.minecraft.silverfish_spawn_egg": "Жоом төрүүлэх өндөг",
  "item.minecraft.skeleton_horse_spawn_egg": "Араг ясан морь төрүүлэх өндөг",
  "item.minecraft.skeleton_spawn_egg": "Араг яс төрүүлэх өндөг",
  "item.minecraft.skull_banner_pattern": "Тугийн хэв",
  "item.minecraft.skull_banner_pattern.desc": "Гавлын яс",
  "item.minecraft.skull_banner_pattern.new": "Гавал тугны хэв",
  "item.minecraft.skull_pottery_shard": "Гавлын ясан хээтэй ваарын хэлтэрхий",
  "item.minecraft.skull_pottery_sherd": "Гавлын ясан хээтэй ваарын хэлтэрхий",
  "item.minecraft.slime_ball": "Салс бөмбөг",
  "item.minecraft.slime_spawn_egg": "Салстан төрүүлэх өндөг",
  "item.minecraft.smithing_template": "Дархны хэв",
  "item.minecraft.smithing_template.applies_to": "Хэрэглэгдэх зүйл:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Гулдмай эсвэл болор нэмэх",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Хуяг дуулга",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Хуяг нэмэх",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Гулдмай болон болрууд",
  "item.minecraft.smithing_template.ingredients": "Найрлага:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Недерит нэмэх",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Алмаасан хэрэглэл",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Алмаасан хуяг, зэвсэг эсвэл багажаа нэмэх",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Недерит",
  "item.minecraft.smithing_template.upgrade": "Сайжруулах: ",
  "item.minecraft.sniffer_spawn_egg": "Шиншигч төрүүлэх өндөг",
  "item.minecraft.snort_pottery_shard": "Тургих хээтэй ваарын хэлтэрхий",
  "item.minecraft.snort_pottery_sherd": "Тургих хээтэй ваарын хэлтэрхий",
  "item.minecraft.snout_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Хамар хуягийн эмжээр",
  "item.minecraft.snow_golem_spawn_egg": "Цасан хүн төрүүлэх өндөг",
  "item.minecraft.snowball": "Цасан бөмбөг",
  "item.minecraft.spectral_arrow": "Тодруулагч сум",
  "item.minecraft.spider_eye": "Аалзны нүд",
  "item.minecraft.spider_spawn_egg": "Аалз төрүүлэх өндөг",
  "item.minecraft.spire_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Оргил хуягийн эмжээр",
  "item.minecraft.splash_potion": "Шиддэг ханд",
  "item.minecraft.splash_potion.effect.awkward": "Шиддэг эвгүй ханд",
  "item.minecraft.splash_potion.effect.empty": "Шиддэг гаргах боломжгүй ханд",
  "item.minecraft.splash_potion.effect.fire_resistance": "Галд тэсвэртэй болгох шиддэг ханд",
  "item.minecraft.splash_potion.effect.harming": "Хохирол учруулах шиддэг ханд",
  "item.minecraft.splash_potion.effect.healing": "Амь нэмэх шиддэг ханд",
  "item.minecraft.splash_potion.effect.infested": "Шиддэг бөөстүүлэх ханд",
  "item.minecraft.splash_potion.effect.invisibility": "Үл үзэгдүүлэх шиддэг ханд",
  "item.minecraft.splash_potion.effect.leaping": "Өндөр үсэргэх шиддэг ханд",
  "item.minecraft.splash_potion.effect.levitation": "Хөөргөх шиддэг ханд",
  "item.minecraft.splash_potion.effect.luck": "Азын шиддэг ханд",
  "item.minecraft.splash_potion.effect.mundane": "Шиддэг хар ханд",
  "item.minecraft.splash_potion.effect.night_vision": "Харанхуйд харуулах шиддэг ханд",
  "item.minecraft.splash_potion.effect.oozing": "Шиддэг өндөр салс дуслуулах ханд",
  "item.minecraft.splash_potion.effect.poison": "Хортой шиддэг ханд",
  "item.minecraft.splash_potion.effect.regeneration": "Амь нөхөх шиддэг ханд",
  "item.minecraft.splash_potion.effect.slow_falling": "Өд шиг хөнгөн болгох шиддэг ханд",
  "item.minecraft.splash_potion.effect.slowness": "Удаашруулах шиддэг ханд",
  "item.minecraft.splash_potion.effect.strength": "Хүч оруулах шиддэг ханд",
  "item.minecraft.splash_potion.effect.swiftness": "Хурдлуулах шиддэг ханд",
  "item.minecraft.splash_potion.effect.thick": "Шиддэг өтгөн ханд",
  "item.minecraft.splash_potion.effect.turtle_master": "Яст мэлхий мастерийн шиддэг ханд",
  "item.minecraft.splash_potion.effect.water": "Шиддэг устай лонх",
  "item.minecraft.splash_potion.effect.water_breathing": "Усанд амьсгалуулах шиддэг ханд",
  "item.minecraft.splash_potion.effect.weakness": "Хүчгүй болгох шиддэг ханд",
  "item.minecraft.splash_potion.effect.weaving": "Шиддэг нэхмэлийн ханд",
  "item.minecraft.splash_potion.effect.wind_charged": "Шиддэг салхиар цэнэглэх ханд",
  "item.minecraft.spruce_boat": "Гацуур модон завь",
  "item.minecraft.spruce_chest_boat": "Авдартай гацуур модон завь",
  "item.minecraft.spyglass": "Дуран",
  "item.minecraft.squid_spawn_egg": "Наймалж төрүүлэх өндөг",
  "item.minecraft.stick": "Савх",
  "item.minecraft.stone_axe": "Чулуун сүх",
  "item.minecraft.stone_hoe": "Чулуун зээтүү",
  "item.minecraft.stone_pickaxe": "Чулуун ёотуу",
  "item.minecraft.stone_shovel": "Чулуун хүрз",
  "item.minecraft.stone_spear": "Чулуун жад",
  "item.minecraft.stone_sword": "Чулуун сэлэм",
  "item.minecraft.stray_spawn_egg": "Тэнүүчлэгч төрүүлэх өндөг",
  "item.minecraft.strider_spawn_egg": "Хайлмалхагч төрүүлэх өндөг",
  "item.minecraft.string": "Утас",
  "item.minecraft.sugar": "Элсэн чихэр",
  "item.minecraft.suspicious_stew": "Сэжигтэй шөл",
  "item.minecraft.sweet_berries": "Чихэрлэг жимсгэнэ",
  "item.minecraft.tadpole_bucket": "Шанаган хорхойтой хувин",
  "item.minecraft.tadpole_spawn_egg": "Шанаган хорхой төрүүлэх өндөг",
  "item.minecraft.tide_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Түрлэг хуягийн эмжээр",
  "item.minecraft.tipped_arrow": "Хандтай сум",
  "item.minecraft.tipped_arrow.effect.awkward": "Хандтай сум",
  "item.minecraft.tipped_arrow.effect.empty": "Урлах боломжгүй хандтай сум",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Галд тэсвэртэй болгох сум",
  "item.minecraft.tipped_arrow.effect.harming": "Хохирол учруулах сум",
  "item.minecraft.tipped_arrow.effect.healing": "Амь нэмэх сум",
  "item.minecraft.tipped_arrow.effect.infested": "Бөөстүүлэх сум",
  "item.minecraft.tipped_arrow.effect.invisibility": "Үл үзэгдүүлэх сум",
  "item.minecraft.tipped_arrow.effect.leaping": "Өндөр үсэргэх сум",
  "item.minecraft.tipped_arrow.effect.levitation": "Хөөргөх сум",
  "item.minecraft.tipped_arrow.effect.luck": "Азын сум",
  "item.minecraft.tipped_arrow.effect.mundane": "Хандтай сум",
  "item.minecraft.tipped_arrow.effect.night_vision": "Харанхуйд харуулах сум",
  "item.minecraft.tipped_arrow.effect.oozing": "Салс дуслуулах сум",
  "item.minecraft.tipped_arrow.effect.poison": "Хортой сум",
  "item.minecraft.tipped_arrow.effect.regeneration": "Амь нөхөх сум",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Өд шиг хөнгөн болгох сум",
  "item.minecraft.tipped_arrow.effect.slowness": "Удаашруулах сум",
  "item.minecraft.tipped_arrow.effect.strength": "Хүч оруулах сум",
  "item.minecraft.tipped_arrow.effect.swiftness": "Хурдлуулах сум",
  "item.minecraft.tipped_arrow.effect.thick": "Хандтай сум",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Яст мэлхий мастерийн сум",
  "item.minecraft.tipped_arrow.effect.water": "Цалгих сум",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Усанд амьсгалуулах сум",
  "item.minecraft.tipped_arrow.effect.weakness": "Хүчгүй болгох сум",
  "item.minecraft.tipped_arrow.effect.weaving": "Нэхмэлийн сум",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Салхиар цэнэглэх сум",
  "item.minecraft.tnt_minecart": "Тэслэгчтэй тэрэг",
  "item.minecraft.torchflower_seeds": "Бамбар цэцгийн үр",
  "item.minecraft.totem_of_undying": "Үхэшгүй мөнхийн сахиус",
  "item.minecraft.trader_llama_spawn_egg": "Худалдаачны тэмээн гөрөөс төрүүлэх өндөн",
  "item.minecraft.trial_key": "Сорилгын түлхүүр",
  "item.minecraft.trident": "Сэрээ таяг",
  "item.minecraft.tropical_fish": "Халуун орны загас",
  "item.minecraft.tropical_fish_bucket": "Халуун орны загастай хувин",
  "item.minecraft.tropical_fish_spawn_egg": "Халуун орны загас төрүүлэх",
  "item.minecraft.turtle_helmet": "Яст мэлхийн хуяг",
  "item.minecraft.turtle_scute": "Яст мэлхийн хуягны хэлтэрхий",
  "item.minecraft.turtle_spawn_egg": "Яст мэлхий төрүүлэх өндөг",
  "item.minecraft.vex_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Залхаагч хуягийн эмжээр",
  "item.minecraft.vex_spawn_egg": "Залхаагч төрүүлэх өндөг",
  "item.minecraft.villager_spawn_egg": "Тосгоны иргэн төрүүлэх өндөг",
  "item.minecraft.vindicator_spawn_egg": "Дагалдагч төрүүлэх өндөг",
  "item.minecraft.wandering_trader_spawn_egg": "Аялагч худалдаачин төрүүлэх өндөг",
  "item.minecraft.ward_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Сахиул хуягийн эмжээр",
  "item.minecraft.warden_spawn_egg": "Сахиул төрүүлэх өндөг",
  "item.minecraft.warped_fungus_on_a_stick": "Гажуудсан мөөгтэй уурга",
  "item.minecraft.water_bucket": "Устай хувин",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Замчлагч хуягийн эмжээр",
  "item.minecraft.wheat": "Улаан буудай",
  "item.minecraft.wheat_seeds": "Улаан буудайн үр",
  "item.minecraft.white_bundle": "Цагаан богц",
  "item.minecraft.white_dye": "Цагаан будаг",
  "item.minecraft.white_harness": "Цагаан тоног",
  "item.minecraft.wild_armor_trim_smithing_template": "Дархны хэв",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Шугуйн хуягийн эмжээр",
  "item.minecraft.wind_charge": "Салхин бөмбөг",
  "item.minecraft.witch_spawn_egg": "Шулам төрүүлэх өндөг",
  "item.minecraft.wither_skeleton_spawn_egg": "Витер араг яс төрүүлэх өндөг",
  "item.minecraft.wither_spawn_egg": "Витер төрүүлэх өндөг",
  "item.minecraft.wolf_armor": "Чононы хуяг",
  "item.minecraft.wolf_spawn_egg": "Чоно төрүүлэх өндөг",
  "item.minecraft.wooden_axe": "Модон сүх",
  "item.minecraft.wooden_hoe": "Модон зээтүү",
  "item.minecraft.wooden_pickaxe": "Модон ёотуу",
  "item.minecraft.wooden_shovel": "Модон хүрз",
  "item.minecraft.wooden_spear": "Модон жад",
  "item.minecraft.wooden_sword": "Модон сэлэм",
  "item.minecraft.writable_book": "Ном болон үзэг",
  "item.minecraft.written_book": "Бичсэн ном",
  "item.minecraft.yellow_bundle": "Шар богц",
  "item.minecraft.yellow_dye": "Шар будаг",
  "item.minecraft.yellow_harness": "Шар тоног",
  "item.minecraft.zoglin_spawn_egg": "Зоглин төрүүлэх өндөг",
  "item.minecraft.zombie_horse_spawn_egg": "Зомби морь төрүүлэх өндөг",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Зомби төрүүлэх өндөг",
  "item.minecraft.zombie_villager_spawn_egg": "Зомби тосгоны иргэн төрүүлэх өндөг",
  "item.minecraft.zombified_piglin_spawn_egg": "Зомбижсон пиглин төрүүлэх өндөг"
}
export const mn_mn = items; 
